<template>
  <div>
    <div class="common-sidebar-right">
      <b-sidebar id="newViewCandidate" right shadow v-model="showModal">
        <header>
          <div class="d-flex align-items-center justify-content-between p-3">
            <div
              class="position-absolute pointer newJD-backArrow"
              @click="showSpinner ? '' : closemodal()"
            >
              <img
                src="../../../assets/img/accessconnew/boxBackArrow.svg"
                alt
              />
            </div>
            <div class="newJD-heading ml-4 pt-1">Preview Candidate</div>
            <div class="d-flex align-items-center preview-cand-top-btns-cont">
              <template v-if="selectedCandidate">
                <div
                  v-if="
                    (selectedCandidate.documentStatus == 4 ||
                      selectedCandidate.documentStatus == 2 ||
                      (!vendor && selectedCandidate.documentStatus == 5)) &&
                    !getDocsRejRec &&
                    selectedCandidate.kanbanLevel != 'R' &&
                    selectedCandidate.kanbanLevel != 'NI' &&
                    selectedCandidate.kanbanLevel != 'F' &&
                    candidateDocsUploaded
                  "
                  class="
                    preview-cand-top-btns
                    vc-blue-txt-2
                    d-flex
                    align-items-center
                    mr-2
                    pointer
                  "
                  @click="
                    !jobOnHold &&
                      $emit('goto-viewodcs', selectedCandidate.candidateID)
                  "
                  :class="jobOnHold && 'disabled-kanban-img'"
                >
                  <img
                    height="20"
                    width="20"
                    src="../../../assets/img/newkanban/reviewdocuments.svg"
                    class="mr-2"
                    alt=""
                  />
                  Review Documents
                </div>
              </template>
              <div
                v-if="!candidateData.active && showActivate"
                class="preview-cand-top-btns pointer"
                @click="activateCand()"
              >
                <img
                  class="mr-2"
                  src="../../../assets/new-icons/activate.svg"
                  alt=""
                />
                Activate
              </div>

              <div
                v-if="showNote"
                @click="!jobOnHold ? showAddNote('add') : ''"
                :class="jobOnHold && 'disabled-kanban-img'"
                class="pointer preview-cand-top-btns mr-2"
              >
                <img
                  class="mr-1"
                  src="../../../assets/new-icons/comment-dots-plus.svg"
                  alt="note"
                />
                Add Note
              </div>
              <div
                class="rotate-on-hover pointer"
                @click="showSpinner ? '' : closemodal()"
              >
                <img
                  v-b-tooltip.hover.top="'Close'"
                  src="../../../assets/img/accessconnew/blueCross.svg"
                  alt
                />
              </div>
            </div>
          </div>
        </header>
        <hr class="my-0" />
        <div class="d-flex w-100 newJD-preview-overflow">
          <div class="pr-3" style="width: 40%">
            <div
              v-if="vendor && candAddedToJob"
              style="height: 130px"
              class="d-flex justify-content-center relativeclass"
            >
              <div class="d-flex" style="position: absolute; top: 20px">
                <div class="position-relative d-flex align-items-center">
                  <div class="d-flex flex-column align-items-center">
                    <img
                      src="../../../assets/img/newvendorflow/activetick.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="vkcanddetails-tab-line d-flex align-items-center"
                  ></div>
                  <div
                    style="top: 35px; left: -15px"
                    class="
                      position-absolute
                      d-flex
                      align-items-center
                      justify-content-center
                      flex-column
                    "
                  >
                    <div class="kanban-ac-smalltxt">
                      {{ candidateStatus.addedDate }}
                    </div>
                    <div class="kanban-ac-asmnttxt">Added</div>
                  </div>
                </div>
                <div class="position-relative d-flex align-items-center">
                  <div class="d-flex flex-column align-items-center">
                    <img
                      v-if="!candidateStatus.shortListedDate"
                      src="../../../assets/img/newvendorflow/natick.svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../../assets/img/newvendorflow/activetick.svg"
                      alt=""
                    />
                  </div>
                  <div
                    :class="
                      !candidateStatus.interview &&
                      'vkcanddetails-tab-line-inactive'
                    "
                    class="vkcanddetails-tab-inactive-line"
                  ></div>
                  <div
                    v-if="candidateStatus.shortListedDate"
                    style="top: 35px; left: -15px"
                    class="
                      position-absolute
                      d-flex
                      align-items-center
                      justify-content-center
                      flex-column
                    "
                  >
                    <div class="kanban-ac-smalltxt">
                      {{ candidateStatus.shortListedDate }}
                    </div>
                    <div class="kanban-ac-asmnttxt">Pushed</div>
                    <div class="kanban-ac-smalltxt">Vendor</div>
                  </div>
                  <div
                    v-else
                    style="top: 35px; left: -50px; width: 125px"
                    class="
                      position-absolute
                      d-flex
                      align-items-center
                      justify-content-center
                      flex-column
                    "
                  >
                    <div class="kanban-ac-smalltxt">N/A</div>
                  </div>
                </div>
                <div class="position-relative d-flex align-items-center">
                  <div class="d-flex flex-column align-items-center">
                    <img
                      v-if="!candidateStatus.interview"
                      src="../../../assets/img/newvendorflow/natick.svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../../assets/img/newvendorflow/activetick.svg"
                      alt=""
                    />
                  </div>
                  <div
                    :class="
                      !candidateStatus.finalResult &&
                      'vkcanddetails-tab-line-inactive'
                    "
                    class="vkcanddetails-tab-line d-flex align-items-center"
                  ></div>

                  <div
                    v-if="candidateStatus.interview"
                    style="top: 35px; left: -15px"
                    class="
                      position-absolute
                      d-flex
                      align-items-center
                      justify-content-center
                      flex-column
                    "
                  >
                    <div class="kanban-ac-smalltxt">
                      {{ candidateStatus.interview }}
                    </div>
                    <div class="kanban-ac-asmnttxt">Interview</div>
                    <div class="kanban-ac-smalltxt">Recruiter</div>
                  </div>
                  <div
                    v-else
                    style="top: 35px; left: -50px; width: 125px"
                    class="
                      position-absolute
                      d-flex
                      align-items-center
                      justify-content-center
                      flex-column
                    "
                  >
                    <div class="kanban-ac-smalltxt">N/A</div>
                  </div>
                </div>
                <div
                  v-if="candidateStatus.finalResult"
                  class="position-relative d-flex align-items-center"
                >
                  <div class="d-flex flex-column align-items-center">
                    <img
                      :src="
                        getFinalRoundSrc(candidateStatus.finalResult.status)
                      "
                      alt=""
                    />
                  </div>
                  <div
                    style="top: 35px; left: -50px; width: 125px"
                    class="
                      position-absolute
                      d-flex
                      align-items-center
                      justify-content-center
                      flex-column
                    "
                  >
                    <div class="kanban-ac-smalltxt">
                      {{ candidateStatus.finalResult.date }}
                    </div>
                    <div
                      :style="getTextColor(candidateStatus.finalResult.status)"
                      class="kanban-ac-asmnttxt"
                    >
                      {{ candidateStatus.finalResult.description }}
                    </div>
                  </div>
                </div>
                <div v-else class="position-relative d-flex align-items-center">
                  <div class="d-flex flex-column align-items-center">
                    <img
                      src="../../../assets/img/newvendorflow/natick.svg"
                      alt=""
                    />
                  </div>
                  <div
                    style="top: 35px; left: -50px; width: 125px"
                    class="
                      position-absolute
                      d-flex
                      align-items-center
                      justify-content-center
                      flex-column
                    "
                  >
                    <div class="kanban-ac-smalltxt">N/A</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="newJD-left-container">
              <div class="newJD-head">Basic Details</div>
              <!-- put for loop -->
              <div
                class="newJD-left-inner-container-preview"
                style="padding: 5px 5px 10px 15px"
              >
                <div
                  class="pr-2 overflow-auto"
                  :style="
                    vendor &&
                    candAddedToJob &&
                    candidateData.isBuilderProfileAvailable &&
                    showProfile
                      ? 'height: calc(100vh - 444px);'
                      : candidateData.isBuilderProfileAvailable && showProfile
                      ? 'height: calc(100vh - 318px);'
                      : vendor && candAddedToJob
                      ? 'height: calc(100vh - 386px);'
                      : 'height: calc(100vh - 258px);'
                  "
                >
                  <div
                    v-for="(field, index) in customFieldsArray"
                    :key="field.key + index"
                  >
                    <template v-if="field.key != 'resume'">
                      <div
                        class="w-100 d-flex align-items-center"
                        :class="index !== 0 ? 'mt-3' : ''"
                      >
                        <div class="newCand-basic-head" style="width: 40%">
                          {{ field.label }}
                        </div>
                        <div
                          class="newCand-basic-content"
                          style="width: 60%"
                          :class="
                            !checkFieldKeys(field) &&
                            field.controlType == 'upload_file'
                              ? 'd-flex align-items-center justify-content-between'
                              : ''
                          "
                        >
                          <template v-if="checkFieldKeys(field)">-</template>
                          <div
                            style="word-break: keep-all"
                            v-else-if="Object.keys(candidateData).length > 0"
                            :class="
                              field.controlType == 'email' ||
                              field.controlType == 'number' ||
                              field.controlType == 'upload_file'
                                ? 'text-truncate'
                                : ''
                            "
                          >
                            <template v-if="isHtmlContent(field)">
                              <div v-html="checkValuesOfKey(field)"></div>
                            </template>
                            <template v-else>
                              <img
                                v-if="
                                  !checkFieldKeys(field) &&
                                  field.controlType == 'upload_file'
                                "
                                class="mr-1"
                                :src="getFileIcon(field)"
                              />
                              {{ checkValuesOfKey(field) }}
                            </template>
                          </div>
                          <div
                            v-if="
                              !checkFieldKeys(field) &&
                              field.controlType == 'upload_file'
                            "
                            class="pointer"
                          >
                            <img
                              @click="downloadFile(field)"
                              class="ml-2"
                              src="../../../assets/talentpool/tp_download_vc.svg"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div class="w-100 d-flex align-items-center mt-3">
                    <div class="newCand-basic-head" style="width: 40%">
                      Created On
                    </div>
                    <div class="newCand-basic-content" style="width: 60%">
                      {{ formattedCreatedAt }}
                    </div>
                  </div>
                  <div class="w-100 d-flex align-items-center mt-3">
                    <div class="newCand-basic-head" style="width: 40%">
                      Created By
                    </div>
                    <div
                      class="newCand-basic-content text-truncate"
                      style="width: 60%; word-break: keep-all"
                    >
                      {{ getUserName ? formattedUsername : "-" }}
                    </div>
                  </div>
                </div>
                <template
                  v-if="candidateData.isBuilderProfileAvailable && showProfile"
                >
                  <hr />
                  <div
                    class="pointer ml-3 text-center"
                    @click="goToCandidateProfile"
                  >
                    <img
                      src="../../../assets/img/accessconnew/blueEye.svg"
                      alt="/"
                      class="pointer"
                    />
                    <span class="ml-2 newCand-view-font">
                      View Candidate Profile
                    </span>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="newJD-right-container relativeclass">
            <div class="newInt-control-tabs relativeclass">
              <b-tabs v-model="tabIndex">
                <b-tab title="Job History" class="pr-1">
                  <div class="newJD-right-innerContent-preview">
                    <template
                      v-if="
                        jobHistory.length === 0 && jobHistoryLoading == true
                      "
                    >
                      <div v-for="i in 3" :key="i">
                        <b-skeleton class="h-100px"></b-skeleton>
                      </div>
                    </template>
                    <div
                      v-else-if="jobHistory.length === 0"
                      class="d-flex align-items-center justify-content-center"
                      style="height: calc(100vh - 277px)"
                    >
                      <img
                        src="../../../assets/new-icons/no-job-history.svg"
                        alt="No Job History"
                      />
                    </div>
                    <div class="h-100" v-else>
                      <div class="common-whiteShadow-card">
                        <b-card
                          :id="'jobhistory' + job.jobID"
                          v-for="(job, index) in jobHistory"
                          :key="job.jobID"
                          :class="
                            index < jobHistory.length - 1 ? 'mb-3' : 'mb-0'
                          "
                        >
                          <div
                            class="
                              view-Cand-blue-card
                              d-flex
                              align-items-center
                              w-100
                              pointer
                            "
                            @click="toggleCollapse(job, index)"
                          >
                            <div class="w-90">
                              {{ job.customerName }} - {{ job.title }}
                            </div>
                            <div
                              class="
                                d-flex
                                align-items-center
                                w-10
                                justify-content-end
                              "
                            >
                              <div
                                :class="
                                  particularJobLoading ||
                                  (historyLoading &&
                                    downloadingJob !== job.jobID)
                                    ? 'disabled-kanban-img'
                                    : 'pointer'
                                "
                                :style="
                                  particularJobLoading ||
                                  (historyLoading &&
                                    downloadingJob == job.jobID &&
                                    'cursor: default !important;')
                                "
                                v-if="
                                  job.jobID === selectedJob.jobID &&
                                  showDownload
                                "
                                @click.stop="
                                  !historyLoading && !particularJobLoading
                                    ? downloadJobHistory(job)
                                    : ''
                                "
                              >
                                <div
                                  v-if="
                                    historyLoading &&
                                    downloadingJob == job.jobID
                                  "
                                  class="download-btn position-relative"
                                  style="top: -6px"
                                >
                                  <img
                                    src="@/assets/talentpool/download-layer.svg"
                                    class="mr-3 icon"
                                    alt=""
                                  />
                                  <div class="d-flex">
                                    <img
                                      src="@/assets/talentpool/down-layer.svg"
                                      class="mr-3 icon-position"
                                      alt=""
                                    />
                                  </div>
                                </div>
                                <span
                                  v-else-if="
                                    !historyLoading && !particularJobLoading
                                  "
                                  v-b-tooltip.hover.bottom="
                                    'Download Job History'
                                  "
                                >
                                  <img
                                    src="../../../assets/talentpool/download.svg"
                                    class="mr-3"
                                    alt=""
                                  />
                                </span>
                                <span v-else>
                                  <img
                                    src="../../../assets/talentpool/download.svg"
                                    class="mr-3"
                                    alt=""
                                  />
                                </span>
                              </div>
                              <div>
                                <img
                                  v-if="job.jobID === selectedJob.jobID"
                                  class="pointer"
                                  src="../../../assets/talentpool/blueuparrow.svg"
                                  alt=""
                                />
                                <img
                                  v-else
                                  class="pointer"
                                  src="../../../assets/talentpool/bluedownarrow.svg"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                          <b-collapse
                            class="p-3 w-100"
                            :id="job.jobID"
                            :visible="job.jobID == selectedJob.jobID"
                          >
                            <div ref="timelineBlock" class="w-100 outer-cont">
                              <div
                                v-if="
                                  selectedJob.jobHistoryVersion == 'v2' &&
                                  particularJob.documents
                                "
                                class="docs-card mb-2"
                              >
                                <b-card>
                                  <section>
                                    <img :src="getDocImage" alt="" />
                                  </section>
                                  <section class="mx-3">
                                    <section class="req-head">
                                      {{ getDocTitle }}
                                    </section>
                                    <section
                                      class="d-flex"
                                      v-if="particularJob.documentStatus === 0"
                                    >
                                      <section class="view-cand-second-head">
                                        Remarks:&nbsp;
                                      </section>
                                      <section class="req-subhead">
                                        {{
                                          particularJob.lastRemark &&
                                          particularJob.lastRemark.remark
                                            ? particularJob.lastRemark.remark
                                            : "-"
                                        }}
                                      </section>
                                    </section>
                                  </section>
                                </b-card>
                              </div>
                              <div
                                v-if="
                                  particularJobLoading &&
                                  job.jobID == selectedJob.jobID
                                "
                                class="text-center"
                              >
                                <b-spinner label="Loading..."></b-spinner>
                              </div>
                              <template
                                v-if="
                                  selectedJob.jobHistoryVersion == 'v2' &&
                                  particularJob.upcomingRounds &&
                                  particularJob.upcomingRounds.length == 0 &&
                                  particularJob.interviewProcess.length == 0 &&
                                  particularJob.status == 'Not Intrested'
                                "
                              >
                                <div class="mt-3">
                                  <div class="d-flex align-items-center w-100">
                                    <div style="width: 40px">
                                      <img
                                        src="../../../assets/new-icons/not-interested.svg"
                                        alt="round"
                                      />
                                    </div>
                                    <div class="w-90">
                                      <div
                                        class="d-flex align-items-center w-100"
                                      >
                                        <div
                                          class="w-60 view-Cand-round-name-font"
                                        >
                                          Not Interested
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </template>
                              <template v-if="job.jobID == selectedJob.jobID">
                                <div
                                  v-for="(
                                    round, index
                                  ) in particularJob.interviewProcess"
                                  :key="index"
                                  :class="
                                    (round.historyType == 3 && !round.state) ||
                                    index <
                                      particularJob.interviewProcess.length - 1
                                      ? 'mb-3'
                                      : 'mb-0'
                                  "
                                  class="w-100"
                                >
                                  <div class="d-flex align-items-center w-100">
                                    <template
                                      v-if="
                                        selectedJob.jobHistoryVersion == 'v3'
                                      "
                                    >
                                      <div style="width: 40px">
                                        <img
                                          v-if="
                                            round.historyType == 4 ||
                                            round.type == 'onboardingDocs'
                                          "
                                          :src="getDocSrc(round)"
                                          alt="round"
                                        />
                                        <img
                                          v-else
                                          :src="getNewRoundSrc(round)"
                                          alt="round"
                                        />
                                      </div>
                                      <div class="w-90">
                                        <template v-if="!showTextCat2(round)">
                                          <div
                                            class="
                                              d-flex
                                              align-items-center
                                              w-100
                                            "
                                          >
                                            <div
                                              class="w-60 view-cand-second-head"
                                              :style="
                                                round.movementType == '29' &&
                                                'margin-bottom: -12px;'
                                              "
                                            >
                                              {{
                                                round.interviewType ==
                                                "alreadyInterviewed"
                                                  ? `Already Interviewed (Status: ${getStatusText(
                                                      round.feedback
                                                        .recommendation
                                                    )})`
                                                  : round.description
                                              }}
                                              <span
                                                class="highlight ml-1"
                                                v-if="
                                                  showSameLineSub(round) &&
                                                  round.historyType != 4 &&
                                                  round.movementType != 2 &&
                                                  round.type != 'onboardingDocs'
                                                "
                                              >
                                                By:
                                                <span
                                                  class="
                                                    preview-cand-sub-name
                                                    email-prot
                                                  "
                                                  ><i
                                                    >{{ round.userName
                                                    }}{{
                                                      round.buHead
                                                        ? " (BU Head)"
                                                        : ""
                                                    }}</i
                                                  ></span
                                                ></span
                                              >
                                            </div>
                                            <div
                                              class="
                                                view-cand-subhead-font
                                                d-flex
                                                align-items-center
                                                w-40
                                                justify-content-end
                                                pointer
                                              "
                                            >
                                              {{ `(${round.createdAt})` }}
                                            </div>
                                          </div>
                                          <div
                                            v-if="
                                              !showSameLineSub(round) ||
                                              showOnboardedDate(round)
                                            "
                                            class="
                                              d-flex
                                              align-items-center
                                              w-100
                                            "
                                          >
                                            <div
                                              class="
                                                w-60
                                                view-Cand-round-name-font
                                              "
                                            >
                                              <span
                                                v-if="
                                                  round.movementType != '29'
                                                "
                                              >
                                                {{
                                                  round.interviewType ==
                                                  "alreadyInterviewed"
                                                    ? getAlrdyIntText(round)
                                                    : cat1SubText(round)
                                                }}
                                                <span
                                                  :class="
                                                    round.interviewType ==
                                                      'alreadyInterviewed' &&
                                                    'font-italic'
                                                  "
                                                >
                                                  {{
                                                    round.interviewType ==
                                                    "alreadyInterviewed"
                                                      ? "(By:"
                                                      : ""
                                                  }}
                                                  <span
                                                    class="
                                                      preview-cand-sub-name
                                                      font-italic
                                                    "
                                                  >
                                                    {{
                                                      showOnboardedDate(round)
                                                        ? convertDateFormat(
                                                            round.onboardingDate
                                                          )
                                                        : round.userName
                                                    }} </span
                                                  >{{
                                                    round.interviewType ==
                                                    "alreadyInterviewed"
                                                      ? ")"
                                                      : ""
                                                  }}
                                                </span>
                                              </span>
                                              <div
                                                v-else-if="
                                                  round.additionalInformation
                                                    .comparisonScore ||
                                                  round.additionalInformation
                                                    .comparisonScore == 0
                                                "
                                                class="
                                                  fs-12
                                                  font-lato
                                                  mt-1
                                                  d-flex
                                                  align-items-center
                                                "
                                              >
                                                <span
                                                  class="color-8c8c8c fw-500"
                                                  >Face Match Rating:</span
                                                >&nbsp;<span
                                                  class="color-mainblue fw-600"
                                                  >{{
                                                    Math.round(
                                                      round
                                                        .additionalInformation
                                                        .comparisonScore
                                                    )
                                                  }}%</span
                                                >
                                                <span
                                                  v-if="
                                                    round.additionalInformation
                                                      .imageCaptured
                                                  "
                                                  ><img
                                                    @click="
                                                      downloadFile(
                                                        round
                                                          .additionalInformation
                                                          .imageCaptured,
                                                        true
                                                      )
                                                    "
                                                    src="../../../assets/New-imgs/switch/roundedarw.svg"
                                                    alt=""
                                                    class="
                                                      ml-2
                                                      mt-n1
                                                      pointer
                                                      remove-from-export
                                                    "
                                                /></span>
                                              </div>
                                            </div>
                                            <div
                                              v-if="
                                                round.type ==
                                                  'onboardingDocs' &&
                                                roles.includes(
                                                  'VIEW_ONBOARDING_DOCS'
                                                )
                                              "
                                              class="
                                                vc-blue-txt
                                                d-flex
                                                align-items-center
                                                w-40
                                                justify-content-end
                                                pointer
                                                remove-from-export
                                              "
                                              :class="
                                                !round.showDocs &&
                                                'disabled-kanban-img'
                                              "
                                              @click="
                                                round.showDocs
                                                  ? gotoFinalDocs()
                                                  : ''
                                              "
                                            >
                                              <span class="blue-border-bottom"
                                                >View Documents</span
                                              >
                                            </div>
                                            <div
                                              v-else-if="showButton(round)"
                                              @click="checkAndApply(round)"
                                              class="
                                                vc-blue-txt
                                                d-flex
                                                align-items-center
                                                w-40
                                                justify-content-end
                                                pointer
                                                remove-from-export
                                              "
                                            >
                                              <span
                                                :class="
                                                  !assessSubEval(round) &&
                                                  round.movementType != '32' &&
                                                  'blue-border-bottom'
                                                "
                                              >
                                                <img
                                                  v-if="
                                                    round.movementType ==
                                                      '32' ||
                                                    assessSubEval(round)
                                                  "
                                                  src="../../../assets/img/newkanban/view-marks.svg"
                                                />
                                                {{ buttonText(round) }}</span
                                              >
                                            </div>
                                          </div>
                                          <div
                                            class="w-90 view-cand-second-head"
                                            v-if="
                                              round.movementType == 19 &&
                                              round.pending
                                            "
                                          >
                                            <template
                                              v-if="round.pending == 'approval'"
                                            >
                                              Select to hire
                                              <span class="position-change-txt"
                                                >(Pending for Approval from BU
                                                Head)</span
                                              >
                                            </template>
                                            <template
                                              v-else-if="
                                                round.pending == 'document'
                                              "
                                            >
                                              Selected, Document approval
                                              pending
                                            </template>
                                          </div>
                                        </template>
                                        <template v-else>
                                          <div
                                            class="
                                              d-flex
                                              align-items-center
                                              w-100
                                            "
                                          >
                                            <div
                                              class="
                                                w-60
                                                view-Cand-round-name-font
                                              "
                                            >
                                              <span
                                                v-if="round.movementType == 41"
                                              >
                                                {{
                                                  `Round ${round.interviewRound} `
                                                }}
                                                <span class="color-brightred"
                                                  >Cancelled</span
                                                >- Face to Face
                                              </span>
                                              <span v-else
                                                >{{ oldRoundType(round) }}
                                              </span>
                                              <span
                                                class="
                                                  highlight
                                                  ml-1
                                                  email-prot
                                                "
                                                v-if="showSubName(round)"
                                              >
                                                (By:
                                                {{
                                                  round.automated &&
                                                  Object.hasOwn(
                                                    round,
                                                    "cancelledBy"
                                                  ) &&
                                                  [2, 3].includes(
                                                    round.cancelledBy
                                                  )
                                                    ? autoCancelName(round)
                                                    : ![
                                                        "47",
                                                        "48",
                                                        "49",
                                                      ].includes(
                                                        round.movementType
                                                      ) &&
                                                      round.automated &&
                                                      (round.cancelledBy == 4 ||
                                                        !Object.hasOwn(
                                                          round,
                                                          "cancelledBy"
                                                        ))
                                                    ? "Hire3x Automated System"
                                                    : ["33", "34"].includes(
                                                        round.movementType
                                                      )
                                                    ? "Hire3x AI"
                                                    : round.userName
                                                }})
                                              </span>
                                            </div>
                                            <div
                                              v-if="round.feedback != null"
                                              class="
                                                vc-blue-txt
                                                d-flex
                                                align-items-center
                                                w-40
                                                justify-content-end
                                                pointer
                                                remove-from-export
                                              "
                                              @click="
                                                round.feedback.feedBackForm &&
                                                round.feedback.feedBackForm
                                                  .panelFeedbackForm
                                                  ? downloadLink(
                                                      round.feedback
                                                        .feedBackForm
                                                        .panelFeedbackForm
                                                    )
                                                  : getFeedBack(round)
                                              "
                                            >
                                              <img
                                                v-if="
                                                  round.feedback.feedBackForm &&
                                                  round.feedback.feedBackForm
                                                    .panelFeedbackForm
                                                "
                                                src="../../../assets/talentpool/download.svg"
                                                class="mr-2 pointer"
                                                alt=""
                                              />
                                              <img
                                                v-else
                                                v-b-popover.hover.top="'View'"
                                                src="../../../assets/talentpool/blueEye.svg"
                                                alt=""
                                                class="mr-2 pointer"
                                              />
                                              <!-- for download icon -->
                                              Feedback Form
                                            </div>
                                            <div
                                              v-else-if="showBotAnalysis(round)"
                                              class="
                                                vc-blue-txt
                                                d-flex
                                                align-items-center
                                                w-40
                                                justify-content-end
                                                pointer
                                                remove-from-export
                                              "
                                              @click="goToBotAnalysis(round)"
                                            >
                                              <img
                                                alt=""
                                                class="mr-2"
                                                height="15"
                                                width="15"
                                                src="@/assets/img/newkanban/botanalysis.svg"
                                              />
                                              View Bot Analysis
                                            </div>
                                            <div
                                              v-else-if="showButton(round)"
                                              @click="checkAndApply(round)"
                                              class="
                                                vc-blue-txt
                                                d-flex
                                                align-items-center
                                                w-40
                                                justify-content-end
                                                pointer
                                                remove-from-export
                                              "
                                            >
                                              <span
                                                :class="
                                                  !assessSubEval(round) &&
                                                  round.movementType != '32' &&
                                                  'blue-border-bottom'
                                                "
                                              >
                                                <img
                                                  v-if="
                                                    round.movementType ==
                                                      '32' ||
                                                    assessSubEval(round)
                                                  "
                                                  src="../../../assets/img/newkanban/view-marks.svg"
                                                />
                                                {{ buttonText(round) }}</span
                                              >
                                            </div>
                                            <div
                                              v-else-if="
                                                round.type != 'attachment'
                                              "
                                              class="
                                                view-cand-subhead-font
                                                d-flex
                                                align-items-center
                                                w-40
                                                justify-content-end
                                                pointer
                                              "
                                            >
                                              {{ `(${round.createdAt})` }}
                                            </div>
                                            <div
                                              v-if="round.type == 'attachment'"
                                              class="
                                                vc-blue-txt
                                                d-flex
                                                align-items-center
                                                w-40
                                                justify-content-end
                                                pointer
                                                remove-from-export
                                              "
                                              @click="
                                                previewType(round) == 'pdf'
                                                  ? previewPdfFiles(
                                                      'Attachment',
                                                      round.media[0]
                                                    )
                                                  : previewImageFiles(
                                                      'Image',
                                                      round.media[0]
                                                    )
                                              "
                                            >
                                              <img
                                                v-b-popover.hover.top="'View'"
                                                src="../../../assets/talentpool/blueEye.svg"
                                                alt=""
                                                class="mr-2 pointer"
                                              />
                                              {{
                                                previewType(round) == "pdf"
                                                  ? "Attachment"
                                                  : "Screenshot"
                                              }}
                                            </div>
                                          </div>
                                          <div class="mt-1">
                                            <div
                                              class="
                                                d-flex
                                                align-items-center
                                                w-100
                                              "
                                            >
                                              <div
                                                :class="
                                                  !assessSubEval(round) &&
                                                  !['32'].includes(
                                                    round.movementType
                                                  ) &&
                                                  !showBotAnalysis(round) &&
                                                  !round.feedback &&
                                                  round.type != 'attachment'
                                                    ? 'w-100'
                                                    : 'w-60'
                                                "
                                                class="view-cand-second-head"
                                              >
                                                <!-- :class="
                                          roundType(round) == 'Note'
                                            ? 'w-100'
                                            : ''
                                        " -->
                                                <template
                                                  v-if="
                                                    round.movementType == 23 ||
                                                    round.movementType == 14
                                                  "
                                                >
                                                  <span
                                                    class="position-change-txt"
                                                    >From
                                                  </span>
                                                  {{
                                                    round.movementType == 14
                                                      ? round.previousRecruiter
                                                      : round.oldPositionID
                                                  }}
                                                  <span
                                                    class="position-change-txt"
                                                    >to
                                                  </span>
                                                  {{
                                                    round.movementType == 14
                                                      ? round.newRecruiter
                                                      : round.newPositionID
                                                  }}
                                                </template>
                                                <template v-else>
                                                  {{
                                                    round.score != null ||
                                                    round.score != undefined
                                                      ? `Score: ${round.score}%`
                                                      : round.note
                                                      ? round.note
                                                      : round.interviewRoundName
                                                      ? round.interviewRoundName
                                                      : round.type ==
                                                        "attachment"
                                                      ? getAttachements(round)
                                                      : round.movementType == 44
                                                      ? `Panel Name: ${round.panelName}`
                                                      : ["45", "46"].includes(
                                                          round.movementType
                                                        )
                                                      ? `Evaluated Name: ${round.panelName}`
                                                      : round.description
                                                  }}</template
                                                >
                                              </div>
                                              <div
                                                v-if="
                                                  assessSubEval(round) ||
                                                  round.feedback ||
                                                  showBotAnalysis(round) ||
                                                  ['32'].includes(
                                                    round.movementType
                                                  ) ||
                                                  round.type == 'attachment'
                                                "
                                                class="
                                                  view-cand-subhead-font
                                                  d-flex
                                                  align-items-center
                                                  w-40
                                                  justify-content-end
                                                  pointer
                                                "
                                              >
                                                {{ `(${round.createdAt})` }}
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            v-if="
                                              round.movementType == '7' &&
                                              (round.additionalInformation
                                                .comparisonScore ||
                                                round.additionalInformation
                                                  .comparisonScore == 0)
                                            "
                                            class="
                                              d-flex
                                              align-items-center
                                              w-100
                                            "
                                          >
                                            <div
                                              class="
                                                fs-12
                                                font-lato
                                                mt-1
                                                d-flex
                                                align-items-center
                                              "
                                            >
                                              <span class="color-8c8c8c fw-500"
                                                >Face Match Rating:</span
                                              >&nbsp;<span
                                                class="color-mainblue fw-600"
                                                >{{
                                                  Math.round(
                                                    round.additionalInformation
                                                      .comparisonScore
                                                  )
                                                }}%</span
                                              >
                                              <span
                                                v-if="
                                                  round.additionalInformation
                                                    .imageCaptured
                                                "
                                                ><img
                                                  @click="
                                                    downloadFile(
                                                      round
                                                        .additionalInformation
                                                        .imageCaptured,
                                                      true
                                                    )
                                                  "
                                                  src="../../../assets/New-imgs/switch/roundedarw.svg"
                                                  alt=""
                                                  class="
                                                    ml-2
                                                    mt-n1
                                                    pointer
                                                    remove-from-export
                                                  "
                                              /></span>
                                            </div>
                                          </div>
                                          <div
                                            v-if="
                                              ['7', '10'].includes(
                                                round.movementType
                                              ) &&
                                              round.date &&
                                              round.startTime
                                            "
                                            class="
                                              d-flex
                                              align-items-center
                                              w-100
                                            "
                                          >
                                            <div
                                              class="
                                                view-Cand-remarks-font
                                                w-90
                                              "
                                            >
                                              Interview Date & Time:
                                              <span style="font-weight: 600">
                                                {{
                                                  round.automated
                                                    ? formatUTCToIST(
                                                        round.startTime
                                                      )
                                                    : convertDateTime(
                                                        `${round.date} ${round.startTime}`
                                                      )
                                                }}
                                              </span>
                                            </div>
                                          </div>
                                        </template>
                                        <div
                                          v-if="
                                            round.movementType == 31 &&
                                            (round.additionalInformation
                                              .comparisonScore ||
                                              round.additionalInformation
                                                .comparisonScore == 0)
                                          "
                                          class="
                                            fs-12
                                            font-lato
                                            mt-1
                                            d-flex
                                            align-items-center
                                          "
                                        >
                                          <span class="color-8c8c8c fw-500"
                                            >Face Match Rating:</span
                                          >&nbsp;<span
                                            class="color-mainblue fw-600"
                                            >{{
                                              Math.round(
                                                round.additionalInformation
                                                  .comparisonScore
                                              )
                                            }}%</span
                                          >
                                          <span
                                            v-if="
                                              round.additionalInformation
                                                .imageCaptured
                                            "
                                            ><img
                                              @click="
                                                downloadFile(
                                                  round.additionalInformation
                                                    .imageCaptured,
                                                  true
                                                )
                                              "
                                              src="../../../assets/New-imgs/switch/roundedarw.svg"
                                              alt=""
                                              class="
                                                ml-2
                                                mt-n1
                                                pointer
                                                remove-from-export
                                              "
                                          /></span>
                                        </div>
                                        <div v-if="round.remarks">
                                          <div style="width: 40px"></div>
                                          <div
                                            class="view-Cand-remarks-font w-100"
                                          >
                                            Remarks:
                                            <span
                                              style="
                                                font-weight: 600;
                                                word-break: break-all;
                                              "
                                            >
                                              {{ round.remarks }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </template>

                                    <!-- if old data -->
                                    <template v-else>
                                      <div style="width: 40px">
                                        <img
                                          v-if="round.historyType == 3"
                                          :src="getFeedbackSrc(round)"
                                          alt="round history"
                                        />
                                        <img
                                          v-else-if="round.historyType == 4"
                                          :src="getDocSrc(round)"
                                          alt="doc src"
                                        />
                                        <img
                                          v-else
                                          :src="getOldRoundSrc(round)"
                                          alt="round"
                                        />
                                      </div>
                                      <div class="w-90">
                                        <div
                                          class="
                                            d-flex
                                            align-items-center
                                            w-100
                                          "
                                        >
                                          <div
                                            class="
                                              w-60
                                              view-Cand-round-name-font
                                            "
                                            :class="
                                              round.historyType == 4 &&
                                              'view-cand-second-head'
                                            "
                                            :style="
                                              roles.includes(
                                                'VIEW_ONBOARDING_DOCS'
                                              ) &&
                                              round.historyType == 4 &&
                                              round.movementType == 37 &&
                                              'margin-bottom: -24px;'
                                            "
                                          >
                                            {{
                                              round.historyType == 4
                                                ? round.desciption
                                                : roundType(round)
                                            }}
                                            <span
                                              class="highlight"
                                              v-if="roundType(round) == 'Note'"
                                            >
                                              (By: {{ round.userName }})</span
                                            >
                                          </div>
                                          <div
                                            v-if="round.feedback != null"
                                            class="
                                              vc-blue-txt
                                              d-flex
                                              align-items-center
                                              w-40
                                              justify-content-end
                                              pointer
                                              remove-from-export
                                            "
                                            @click="
                                              round.feedback.feedBackForm &&
                                              round.feedback.feedBackForm
                                                .panelFeedbackForm
                                                ? downloadLink(
                                                    round.feedback.feedBackForm
                                                      .panelFeedbackForm
                                                  )
                                                : viewFeedback(round)
                                            "
                                          >
                                            <img
                                              v-if="
                                                round.feedback.feedBackForm &&
                                                round.feedback.feedBackForm
                                                  .panelFeedbackForm
                                              "
                                              src="../../../assets/talentpool/download.svg"
                                              class="mr-2 pointer"
                                              alt=""
                                            />
                                            <img
                                              v-else
                                              v-b-popover.hover.top="'View'"
                                              src="../../../assets/talentpool/blueEye.svg"
                                              alt=""
                                              class="mr-2 pointer"
                                            />
                                            <!-- for download icon -->
                                            Feedback Form
                                          </div>
                                          <div
                                            v-else-if="
                                              roundType(round) === 'Note'
                                            "
                                            class="
                                              view-cand-subhead-font
                                              d-flex
                                              align-items-center
                                              w-40
                                              justify-content-end
                                              pointer
                                            "
                                          >
                                            {{
                                              round.feedback == null &&
                                              round.historyType == 1
                                                ? "No Feedback"
                                                : round.createdAt
                                            }}
                                          </div>
                                          <div
                                            v-if="
                                              roundType(round) == 'Attachment'
                                            "
                                            class="
                                              vc-blue-txt
                                              d-flex
                                              align-items-center
                                              w-40
                                              justify-content-end
                                              pointer
                                              remove-from-export
                                            "
                                            @click="
                                              previewType(round) == 'pdf'
                                                ? previewPdfFiles(
                                                    'Attachment',
                                                    round.media[0]
                                                  )
                                                : previewImageFiles(
                                                    'Image',
                                                    round.media[0]
                                                  )
                                            "
                                          >
                                            <img
                                              v-b-popover.hover.top="'View'"
                                              src="../../../assets/talentpool/blueEye.svg"
                                              alt=""
                                              class="mr-2 pointer"
                                            />
                                            {{
                                              previewType(round) == "pdf"
                                                ? "Attachment"
                                                : "Screenshot"
                                            }}
                                          </div>
                                          <div
                                            v-if="
                                              round.historyType == 4 &&
                                              roles.includes(
                                                'VIEW_ONBOARDING_DOCS'
                                              )
                                            "
                                            class="
                                              vc-blue-txt
                                              d-flex
                                              align-items-center
                                              w-40
                                              justify-content-end
                                              pointer
                                              remove-from-export
                                            "
                                            :class="
                                              !round.showDocs &&
                                              'disabled-kanban-img'
                                            "
                                            @click="
                                              round.showDocs
                                                ? gotoFinalDocs()
                                                : ''
                                            "
                                          >
                                            <span class="blue-border-bottom"
                                              >View Documents</span
                                            >
                                          </div>
                                        </div>
                                        <div class="mt-1">
                                          <div
                                            class="
                                              d-flex
                                              align-items-center
                                              w-100
                                            "
                                          >
                                            <div
                                              class="w-60 view-cand-second-head"
                                              :class="
                                                roundType(round) == 'Note'
                                                  ? 'w-100'
                                                  : ''
                                              "
                                            >
                                              <template
                                                v-if="
                                                  round.historyType == 3 &&
                                                  !round.state &&
                                                  round.desciption
                                                "
                                              >
                                                <span
                                                  class="position-change-txt"
                                                  >{{
                                                    round.desciption.split(
                                                      " "
                                                    )[0]
                                                  }}
                                                </span>
                                                {{
                                                  round.desciption.split(" ")[1]
                                                }}
                                                <span
                                                  class="position-change-txt"
                                                  >{{
                                                    round.desciption.split(
                                                      " "
                                                    )[2]
                                                  }}
                                                </span>
                                                {{
                                                  round.desciption.split(" ")[3]
                                                }}
                                              </template>
                                              <div
                                                v-else-if="
                                                  round.historyType == 4 &&
                                                  round.movementType != 37
                                                "
                                                class="
                                                  view-Cand-remarks-font
                                                  w-90
                                                "
                                              >
                                                {{
                                                  round.movementType == 36
                                                    ? "Requested By:"
                                                    : "Evaluated By:"
                                                }}
                                                <span style="font-weight: 600">
                                                  {{ round.userName }}
                                                </span>
                                              </div>
                                              <template v-else>
                                                {{
                                                  roundType(round) == "Note"
                                                    ? round.note
                                                    : roundType(round) ==
                                                      "Attachment"
                                                    ? getAttachements(round)
                                                    : round.historyType == 3
                                                    ? getStatusText(round.state)
                                                    : round.name
                                                }}
                                              </template>
                                            </div>
                                            <div
                                              v-if="roundType(round) != 'Note'"
                                              class="
                                                view-cand-subhead-font
                                                d-flex
                                                align-items-center
                                                w-40
                                                justify-content-end
                                                pointer
                                              "
                                            >
                                              {{
                                                round.feedback == null &&
                                                round.historyType == 1
                                                  ? "No Feedback"
                                                  : `(${round.createdAt})`
                                              }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                  <!-- <div
                                class="d-flex align-items-center w-100 mt-1"
                                v-if="
                                  !['36', '37','21', '22', '15','16'].includes(round.movementType) &&
                                  round.remarks &&
                                  !round.pending &&
                                  round.remarks != '' &&
                                  round.remarks != null
                                "
                              >
                                <div style="width: 40px"></div>
                                <div class="view-Cand-remarks-font w-90">
                                  Remarks:
                                  <span style="font-weight: 600">
                                    {{ round.remarks }}
                                  </span>
                                </div>
                              </div> -->
                                </div>
                              </template>
                              <div
                                v-for="(
                                  round, index
                                ) in particularJob.upcomingRounds"
                                :key="round.interviewRound"
                                :class="{
                                  'mb-3':
                                    index <
                                    particularJob.upcomingRounds.length - 1,
                                  'mt-3': index == 0,
                                  'mb-0':
                                    index != 0 &&
                                    index <
                                      particularJob.upcomingRounds.length - 1,
                                }"
                              >
                                <div class="d-flex w-100">
                                  <div style="width: 40px">
                                    <img
                                      :src="getUpcomingRoundSrc(round)"
                                      alt="round"
                                    />
                                  </div>
                                  <div class="w-90">
                                    <div
                                      class="d-flex align-items-center w-100"
                                    >
                                      <div
                                        class="w-60 view-Cand-round-name-font"
                                      >
                                        {{ roundType(round) }}
                                      </div>
                                    </div>
                                    <div class="mt-1">
                                      <div
                                        class="d-flex align-items-center w-100"
                                      >
                                        <div class="w-60 view-cand-second-head">
                                          {{ round.name }}
                                        </div>
                                        <div
                                          class="
                                            view-cand-subhead-font
                                            d-flex
                                            align-items-center
                                            w-40
                                            justify-content-end
                                            pointer
                                          "
                                          style="
                                            position: relative;
                                            right: 0px;
                                            top: -11px;
                                          "
                                        >
                                          No Feedback
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  class="d-flex align-items-center w-100 mt-1"
                                  v-if="
                                    round.remarks &&
                                    round.remarks != '' &&
                                    round.remarks != null
                                  "
                                >
                                  <div style="width: 40px"></div>
                                  <div class="view-Cand-remarks-font w-90">
                                    Remarks:
                                    <span
                                      style="
                                        font-weight: 600;
                                        word-break: break-all;
                                      "
                                    >
                                      {{ round.remarks }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-collapse>
                        </b-card>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Notes" class="pr-1" @click="setNotesID()">
                  <div
                    v-if="notes.recent.length == 0"
                    class="d-flex align-items-center justify-content-center"
                    style="height: calc(100vh - 277px)"
                  >
                    <img
                      src="../../../assets/new-icons/no-notes.svg"
                      alt="No Notes"
                    />
                  </div>
                  <div
                    v-else
                    class="newJD-right-innerContent-preview overflow-hidden"
                    style="height: calc(100vh - 235px)"
                  >
                    <div
                      ref="tagSection"
                      v-if="
                        !roles.includes('GET_VENDOR_DASHBOARD') &&
                        candidateData.customFields.notesTags &&
                        candidateData.customFields.notesTags.length != 0
                      "
                      class="notes-tags-container"
                    >
                      <div
                        class="
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <h6 class="fs-13 fw-500 font-mont color-344054 mb-0">
                          Assigned Tags
                        </h6>
                        <img
                          class="pointer"
                          :class="jobOnHold && 'disabled-kanban-img'"
                          @click="!jobOnHold ? showAddNote('edit') : ''"
                          src="../../../assets/img/botanalysis/kanbantagedit.svg"
                          alt=""
                        />
                      </div>
                      <hr style="border-top: 1px dashed #e1e3e5" class="my-2" />
                      <div
                        class="
                          pc-notes-tags-overflow
                          d-flex
                          align-items-center
                          gap-10
                          flex-wrap
                        "
                        ref="pc-notes-tags-overflow"
                      >
                        <div
                          class="
                            kanbancards-skilltags
                            fs-12
                            fw-400
                            font-lato
                            color-mainblue
                          "
                          style="border: none"
                          v-for="(tag, index) in candidateData.customFields
                            .notesTags"
                          :key="tag + index"
                        >
                          #{{ tag }}
                        </div>
                      </div>
                    </div>
                    <section class="mt-3 position-relative">
                      <div
                        class="
                          d-flex
                          align-items-center
                          justify-content-between
                          pc-notes-tabs
                          w-100
                          position-realtive
                        "
                        :class="
                          (!candidateData.customFields.notesTags ||
                            candidateData.customFields.notesTags.length == 0) &&
                          'pc-notes-full'
                        "
                      >
                        <h6 class="fw-500 fs-16 font-lato color-black mb-0">
                          Notes History
                        </h6>
                        <b-tabs ref="noteTabs" pills card>
                          <b-tab
                            title="By Category"
                            @click="
                              notes.category.length == 0
                                ? (getNotes('category'), scrollTop('noteTag'))
                                : ''
                            "
                          >
                            <div v-if="noteLoading">
                              <div
                                class="kanban-skeleton-cards mt-3"
                                v-for="i in 2"
                                :key="i"
                              >
                                <div
                                  v-for="i in 3"
                                  :key="i"
                                  class="d-flex gap-2"
                                >
                                  <div class="w-100 mt-2">
                                    <b-skeleton width="50%"></b-skeleton>

                                    <b-skeleton class="w-75"></b-skeleton>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <template v-else>
                              <section
                                v-for="(category, index) in notes.category"
                                :key="index"
                                :class="index != 0 && 'mt-3'"
                              >
                                <h5 class="font-lato fw-600 fs-14 color-1A4164">
                                  {{
                                    category._id
                                      ? `From Job: ${category.jobTitle}`
                                      : "From: Talent Pool"
                                  }}
                                </h5>
                                <section class="notes-category-box">
                                  <section
                                    v-for="(note, ind) in category.notes"
                                    :key="note.noteID"
                                  >
                                    <div
                                      class="
                                        fs-12
                                        fw-600
                                        font-mont
                                        color-mainblue
                                      "
                                    >
                                      {{ note.userName }}
                                      <span
                                        class="
                                          fs-11
                                          fw-500
                                          font-lato font-italic
                                          color-b4b4b4
                                        "
                                        >({{ note.createdAt }})</span
                                      >
                                    </div>
                                    <p
                                      class="
                                        fs-14
                                        fw-600
                                        font-mont
                                        color-3a3c40
                                        m-0
                                        wordbreak
                                      "
                                    >
                                      {{ note.note }}
                                    </p>

                                    <div
                                      v-if="note.tags && note.tags.length != 0"
                                      class="
                                        d-flex
                                        align-items-center
                                        gap-10
                                        flex-wrap
                                        mt-2
                                      "
                                    >
                                      <div
                                        class="
                                          kanbancards-skilltags
                                          fs-12
                                          fw-400
                                          font-lato
                                          color-mainblue
                                        "
                                        style="border: none"
                                        v-for="(tag, i) in note.tags"
                                        :key="`cat ${tag + i}`"
                                      >
                                        #{{ tag }}
                                      </div>
                                    </div>
                                    <hr
                                      v-if="ind != category.notes.length - 1"
                                      style="border-top: 1px solid #e8e8e8"
                                    />
                                  </section>
                                </section>
                              </section>
                            </template>
                          </b-tab>
                          <b-tab
                            title="Most Recent"
                            active
                            @click="scrollTop('noteTag')"
                          >
                            <div v-if="noteLoading">
                              <div
                                class="kanban-skeleton-cards mt-3"
                                v-for="i in 2"
                                :key="i"
                              >
                                <div
                                  v-for="i in 3"
                                  :key="i"
                                  class="d-flex gap-2"
                                >
                                  <div class="w-100 mt-2">
                                    <b-skeleton width="50%"></b-skeleton>

                                    <b-skeleton class="w-75"></b-skeleton>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <template v-else>
                              <section
                                v-for="note in notes.recent"
                                :key="note.noteID"
                              >
                                <div
                                  class="fs-12 fw-600 font-mont color-mainblue"
                                >
                                  {{ note.userName }}
                                  <span
                                    class="
                                      fs-11
                                      fw-500
                                      font-lato font-italic
                                      color-b4b4b4
                                    "
                                    >({{ note.createdAt }})</span
                                  >
                                </div>
                                <div
                                  class="
                                    color-6e99be
                                    fs-11
                                    fw-500
                                    font-lato
                                    text-underline
                                    my-2
                                  "
                                >
                                  {{
                                    note.jobTitle
                                      ? `From Job: ${note.jobTitle}`
                                      : "From: Talent Pool"
                                  }}
                                </div>
                                <p
                                  class="
                                    fs-14
                                    fw-600
                                    font-mont
                                    color-3a3c40
                                    m-0
                                    wordbreak
                                  "
                                >
                                  {{ note.note }}
                                </p>

                                <div
                                  v-if="note.tags && note.tags.length != 0"
                                  class="
                                    d-flex
                                    align-items-center
                                    gap-10
                                    flex-wrap
                                    mt-2
                                  "
                                >
                                  <div
                                    class="
                                      kanbancards-skilltags
                                      fs-12
                                      fw-400
                                      font-lato
                                      color-mainblue
                                    "
                                    style="border: none"
                                    v-for="(notetag, index) in note.tags"
                                    :key="notetag + index"
                                  >
                                    #{{ notetag }}
                                  </div>
                                </div>
                                <hr style="border-top: 1px solid #e8e8e8" />
                              </section>
                            </template>
                          </b-tab>
                        </b-tabs>
                      </div>
                      <hr style="border-top: 1px dashed #e1e3e5" />
                    </section>

                    <!-- <div
                      v-if="
                        notes.jobNotes.length === 0 && notes.notes.length === 0
                      "
                      class="d-flex align-items-center justify-content-center"
                      style="height: calc(100vh - 277px)"
                    >
                      <img
                        src="../../../assets/new-icons/no-notes.svg"
                        alt="No Notes"
                      />
                    </div>
                    <div class="common-onlyBorder-card relativeclass" v-else>
                      <template v-if="notes.jobNotes.length">
                        <div class="candidate-notes-head my-2 text-capitalize">
                          From Job: {{ jobHistory[0].title }}
                        </div>
                        <b-card>
                          <div
                            v-for="(note, index) in notes.jobNotes"
                            :key="note.noteID"
                          >
                            <div>
                              <span class="view-cand-head-font mr-2">
                                {{ note.userName }}
                              </span>
                              <span class="view-cand-subhead-font">
                                {{ `(${note.createdAt})` }}
                              </span>
                            </div>
                            <div class="view-cand-font">
                              {{ note.note }}
                            </div>
                            <hr v-if="index < notes.jobNotes.length - 1" />
                          </div>
                        </b-card>
                      </template>
                      <template v-if="notes.notes.length">
                        <div
                          class="candidate-notes-head mb-2"
                          :class="notes.jobNotes.length === 0 ? 'mt-2' : 'mt-4'"
                        >
                          From Talent Pool
                        </div>
                        <b-card>
                          <div
                            v-for="(note, index) in notes.notes"
                            :key="note.noteID"
                          >
                            <div>
                              <span class="view-cand-head-font mr-2">
                                {{ note.userName }}
                              </span>
                              <span class="view-cand-subhead-font">
                                {{ `(${note.createdAt})` }}
                              </span>
                            </div>
                            <div class="view-cand-font">
                              {{ note.note }}
                            </div>
                            <hr v-if="index < notes.notes.length - 1" />
                          </div>
                        </b-card>
                      </template>
                    </div> -->
                  </div>
                </b-tab>
                <b-tab title="Resume" class="pr-1">
                  <div
                    class="p-3 newJD-right-innerContent-preview"
                    style="height: calc(100vh - 235px)"
                  >
                    <template v-if="resumeLoading">
                      <div
                        class="
                          h-100
                          d-flex
                          align-items-center
                          justify-content-center
                        "
                      >
                        <b-spinner label="loading..."></b-spinner>
                      </div>
                    </template>
                    <template v-else>
                      <!-- if word format -->
                      <div
                        v-if="isDocType(resume.link)"
                        class="
                          h-100
                          d-flex
                          align-items-center
                          justify-content-center
                        "
                      >
                        <div class="newCand-word-resume">
                          <div class="text-center">
                            <img
                              src="../../../assets/newJD/newCand-word-doc.svg"
                              alt=""
                            />
                          </div>
                          <div
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                              mt-2
                            "
                          >
                            <div
                              class="newCand-word-resume-font text-truncate"
                              style="width: 85%"
                            >
                              {{ candidateData.name }}'s Resume
                            </div>
                            <div>
                              <img
                                class="mr-2"
                                src="../../../assets/newJD/newCand-line-icon.svg"
                                alt=""
                              />

                              <img
                                class="pointer"
                                src="../../../assets/newJD/newCand-download-icon.svg"
                                alt=""
                                @click="downloadLink(resume.link, 'resume')"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- pdf format -->
                      <div class="h-100" v-else>
                        <div
                          style="height: calc(100vh - 270px)"
                          class="w-100 text-center"
                        >
                          <div class="h-100">
                            <!-- <pdf
                              class="h-100 w-100 viewReseme-canvas"
                              ref="pdf"
                              :src="resume.link"
                              :page="currentPage"
                              @num-pages="numPages = $event"
                              @link-clicked="currentPage = $event"
                              @page-loaded="currentPage = $event"
                            ></pdf> -->
                            <div
                              class="
                                d-flex
                                justify-content-between
                                gap-2
                                align-items-center
                              "
                            >
                              <div
                                class="relativeclass teams-innerInputField w-85"
                              >
                                <img
                                  class="teams-setImage"
                                  src="../../../assets/img/search-bar-icon.svg"
                                  alt=""
                                />
                                <b-form-input
                                  class="search-input"
                                  type="search"
                                  v-model="searchText"
                                  placeholder="Search text in PDF"
                                />
                              </div>

                              <div class="d-flex align-items-center">
                                <div
                                  class="mr-3"
                                  v-if="
                                    resume.link != null &&
                                    !isDocType(resume.link)
                                  "
                                >
                                  <img
                                    @click="downloadLink(resume.link, 'resume')"
                                    class="pointer"
                                    src="../../../assets/newJD/newCand-download-icon.svg"
                                    alt=""
                                  />
                                </div>
                                <div
                                  v-if="
                                    resume.link != null &&
                                    !isDocType(resume.link)
                                  "
                                  @click="
                                    previewPdfFiles('Resume', resume.link)
                                  "
                                >
                                  <img
                                    class="pointer"
                                    src="../../../assets/newJD/newCand-previewresume-icon.svg"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>

                            <PdfSearch
                              :pdfUrl="resume.link"
                              class="w-100 viewReseme-canvas mt-3"
                              :searchText="searchText"
                            ></PdfSearch>
                          </div>
                        </div>
                        <!-- <div
                          class="
                            viewResume-paginaTion-modal
                            align-items-center
                            justify-content-center
                            d-flex
                            w-100
                          "
                        >
                          <div class="pagination">
                            <b-pagination
                              align="center"
                              first-number
                              last-number
                              v-model="currentPage"
                              :total-rows="numPages"
                              :per-page="perPage"
                            >
                              <template #prev-text>
                                <span>
                                  <img
                                    src="../../../assets/img/accessconnew/pageleft.svg"
                                    alt
                                  />
                                </span>
                              </template>
                              <template #next-text>
                                <span>
                                  <img
                                    src="../../../assets/img/accessconnew/pageright.svg"
                                    alt
                                  />
                                </span>
                              </template>
                            </b-pagination>
                          </div>
                        </div> -->
                      </div>
                    </template>
                  </div>
                </b-tab>
                <b-tab
                  title="Report"
                  class="pr-1"
                  v-if="
                    selectedCandidate.reportKey ||
                    selectedCandidate.recommendation ||
                    selectedCandidate.processing ||
                    selectedCandidate.processingFailed
                  "
                >
                  <div
                    class="p-3 newJD-right-innerContent-preview"
                    style="height: calc(100vh - 235px)"
                  >
                    <div
                      v-if="selectedCandidate.recommendation"
                      class="report-fit-band mb-3"
                      :style="verdictColor(selectedCandidate.recommendation)"
                    >
                      {{ verdictLabel(selectedCandidate.recommendation) }}
                    </div>
                    <template v-if="reportLoading">
                      <div
                        class="
                          h-100
                          d-flex
                          align-items-center
                          justify-content-center
                        "
                      >
                        <b-spinner label="loading..."></b-spinner>
                      </div>
                    </template>
                    <div class="h-100" v-else-if="reportLink">
                      <div
                        style="height: calc(100vh - 270px)"
                        class="w-100 text-center"
                      >
                        <div class="h-100">
                          <div
                            class="
                              d-flex
                              justify-content-between
                              gap-2
                              align-items-center
                            "
                          >
                            <div
                              class="relativeclass teams-innerInputField w-85"
                            >
                              <img
                                class="teams-setImage"
                                src="../../../assets/img/search-bar-icon.svg"
                                alt=""
                              />
                              <b-form-input
                                class="search-input"
                                type="search"
                                v-model="reportSearchText"
                                placeholder="Search text in PDF"
                              />
                            </div>

                            <div class="d-flex align-items-center">
                              <div class="mr-3">
                                <img
                                  @click="downloadLink(reportLink, 'report')"
                                  class="pointer"
                                  src="../../../assets/newJD/newCand-download-icon.svg"
                                  alt=""
                                />
                              </div>
                              <div
                                @click="previewPdfFiles('Report', reportLink)"
                              >
                                <img
                                  class="pointer"
                                  src="../../../assets/newJD/newCand-previewresume-icon.svg"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>

                          <PdfSearch
                            :pdfUrl="reportLink"
                            class="w-100 viewReseme-canvas mt-3"
                            :searchText="reportSearchText"
                          ></PdfSearch>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="selectedCandidate.processing"
                      class="
                        h-100
                        d-flex
                        flex-column
                        align-items-center
                        justify-content-center
                        text-muted
                      "
                    >
                      <b-spinner class="mb-2" label="generating..."></b-spinner>
                      Generating the match report. This takes about a minute.
                    </div>
                    <div
                      v-else-if="selectedCandidate.processingFailed"
                      class="
                        h-100
                        d-flex
                        align-items-center
                        justify-content-center
                        text-muted
                      "
                    >
                      Report generation failed. Please trigger it again.
                    </div>
                    <div
                      v-else
                      class="
                        h-100
                        d-flex
                        align-items-center
                        justify-content-center
                        text-muted
                      "
                    >
                      The full report is not available yet.
                    </div>
                  </div>
                </b-tab>
                <!-- CVS tab starts from here which is commented as of now  -->
                <b-tab
                  title="CVS"
                  class="pr-1"
                  @click="checkAndStartCVS()"
                  v-if="showcvstab && !roles.includes('GET_VENDOR_DASHBOARD')"
                >
                  <div
                    class="
                      re-trigger-div
                      m-0
                      px-4
                      py-2
                      d-flex
                      justify-content-between
                    "
                  >
                    <div class="p-0">
                      <section class="d-flex align-items-center w-100">
                        <section class="submitted-font mr-1">
                          Submitted Date:
                        </section>
                        <section
                          ref="closeDateDropdown"
                          v-closable="{
                            exclude: ['closeDateDropdown'],
                            handler: 'handleCloseDateDropdown',
                          }"
                          class="pointer"
                          style="width: 170px"
                          @click="showCard = !showCard"
                        >
                          <section class="date-container w-100 w-100">
                            <div class="date-container-font">
                              {{ getCvsDates[selectedCvsIndex].text }}
                            </div>
                            <div>
                              <img
                                v-if="!showCard"
                                src="../../../assets/img/cvs-downArrow.svg"
                                alt=""
                              />
                              <img
                                v-else
                                height="10"
                                width="10"
                                src="../../../assets/talentpool/blueuparrow.svg"
                                alt=""
                              />
                            </div>
                          </section>
                          <div v-show="showCard" class="relativeclass">
                            <div
                              class="
                                newInt-radio-dropdown
                                p-0
                                w-100
                                cvs-list-drop
                              "
                            >
                              <b-form-group
                                class="sec-mcq-datacard w-100 cvs-list-drop"
                              >
                                <b-form-radio-group
                                  class="
                                    newInt-radio-dropdown-inner-content
                                    w-100
                                  "
                                  size="sm"
                                  @change="changeCvsPreview"
                                  v-model="selectedDate"
                                  :options="getCvsDates"
                                  buttons
                                  stacked
                                >
                                </b-form-radio-group>
                              </b-form-group>
                            </div>
                          </div>
                        </section>
                      </section>
                    </div>
                    <div
                      v-if="
                        ($route.name == 'Kanban' ||
                          $route.name == 'TalentPool') &&
                        roles.includes('TRIGGER_CVS')
                      "
                      class="bluebtn"
                    >
                      <div class="position-relative">
                        <!-- Talent Pool has no job, so re-triggering goes through
                             the parent's Trigger CVS modal to collect skills. -->
                        <b-button
                          class="acs-addBtn-modal"
                          :class="
                            LoaderStatus
                              ? 'cvs-loader-button defaultCursor'
                              : 'pointer'
                          "
                          :disabled="LoaderStatus || jobOnHold"
                          @click="
                            LoaderStatus || jobOnHold
                              ? ''
                              : $route.name == 'TalentPool'
                              ? $emit('retrigger-cvs', candidateID)
                              : reTriggerCvs()
                          "
                          >{{ LoaderStatus ? "" : "Re-Trigger CVS" }}</b-button
                        >
                        <div v-if="LoaderStatus" class="cvs-send-loader">
                          <Loader />
                        </div>
                      </div>
                    </div>
                  </div>
                  <CVSPreview
                    :candidatecvsdata="candidatecvsdata"
                    :selectedCvsIndex="selectedCvsIndex"
                    @scrollToTop="scrollTop('scrollToTop')"
                  />
                </b-tab>

                <!-- tab for showing screening results -->
                <b-tab v-if="showScreeningTab" title="Screening" class="pr-1">
                  <div class="newJD-right-innerContent-preview">
                    <div class="h-100">
                      <div class="common-whiteShadow-card">
                        <b-card
                          v-for="(screening, index) in screeningData"
                          :key="screening._id"
                          :class="
                            index < screeningData.length - 1 ? 'mb-3' : 'mb-0'
                          "
                        >
                          <div
                            class="
                              view-Cand-blue-card
                              d-flex
                              align-items-center
                              w-100
                              pointer
                            "
                            @click="toggleCollapseScreening(screening)"
                          >
                            <div class="w-60 tp-checkbox-text">
                              <span v-if="fromRecKanban">
                                By
                                {{
                                  screening.assignedTo
                                    ? getSubmittedName(screening.assignedTo)
                                    : ""
                                }}
                              </span>
                              <span v-else>
                                {{ screening.jobData.title }}
                              </span>
                            </div>
                            <div
                              class="
                                d-flex
                                align-items-center
                                w-40
                                justify-content-end
                              "
                            >
                              <div class="mr-3 vc-darkgrey-txt">
                                {{ formatDateTime(screening.updatedAt) }}
                              </div>
                              <div>
                                <img
                                  v-if="screening._id === screeningSel._id"
                                  class="pointer"
                                  src="../../../assets/talentpool/blueuparrow.svg"
                                  alt=""
                                />
                                <img
                                  v-else
                                  class="pointer"
                                  src="../../../assets/talentpool/bluedownarrow.svg"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                          <b-collapse
                            class="p-3 w-100"
                            :id="screening._id"
                            :visible="screening._id == screeningSel._id"
                          >
                            <div
                              class="d-flex w-100 justify-content-end"
                              v-if="!fromRecKanban"
                            >
                              <div class="vc-darkgrey-txt text-truncate">
                                By
                                {{
                                  screening.assignedTo
                                    ? getSubmittedName(screening.assignedTo)
                                    : ""
                                }}
                              </div>
                            </div>
                            <div class="mb-3">
                              <InputField
                                :type="'text'"
                                :label="'Recommendation'"
                                :mandatory="true"
                                :vmodel="
                                  getRecValue(screening.feedback.recommendation)
                                "
                                :disabled="true"
                              />
                              <div class="newmodalinputbox mt-3">
                                <div class="jdk-ip-confirm-subtxt">
                                  Remarks<span class="asterik">*</span>
                                </div>
                                <b-form-textarea
                                  class="overflow-auto"
                                  rows="2"
                                  type="text"
                                  v-model="
                                    screening.feedback.recommendationComments
                                  "
                                  max-rows="5"
                                  disabled
                                  placeholder="Enter"
                                  value=""
                                />
                              </div>
                            </div>
                            <hr class="my-2" />
                            <div
                              class="mt-3 newInt-inner-containers"
                              v-for="(input, k) in screening.feedback.skills"
                              :key="k"
                            >
                              <div>
                                <div class="d-flex justify-content-between">
                                  <div
                                    class="
                                      newInt-inner-containers-head
                                      mb-2
                                      text-truncate
                                    "
                                  >
                                    {{ input.name }}
                                  </div>

                                  <div class="d-flex mt-1">
                                    <div
                                      class="newInt-inner-containers-subhead"
                                    >
                                      Rating
                                    </div>
                                    <div style="margin-top: -11px">
                                      <b-form-rating
                                        variant="primary"
                                        class="mb-2 newInt-rating p-0 w-25 ml-2"
                                        disabled
                                        v-model="input.mark"
                                      ></b-form-rating>
                                    </div>
                                  </div>
                                </div>
                                <div v-if="input.comments" class="topDiv">
                                  <label class="jdk-ip-confirm-subtxt"
                                    >Comments:</label
                                  >
                                  <div
                                    class="mt-1 teams-label-font"
                                    style="line-height: 22px"
                                  >
                                    {{ input.comments }}
                                    <!-- <b-form-textarea
                      class="newInt-previewInputField"
                      placeholder="Comments will be shown here"
                      disabled
                      v-model="input.comments"
                      rows="3"
                      max-rows="4"
                    >
                    </b-form-textarea> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-collapse>
                        </b-card>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab
                  @click="selectedDoc = null"
                  v-if="!vendor && showDocuments"
                  title="Documents"
                >
                  <div
                    v-if="!selectedDoc"
                    class="newJD-right-innerContent-preview"
                  >
                    <article
                      v-for="(doc, index) in documentData"
                      :key="doc.key"
                      class="
                        pcs-doc-cards
                        d-flex
                        align-items-center
                        justify-content-between
                      "
                      :class="index != 0 && 'mt-3'"
                    >
                      <section class="d-flex align-items-center">
                        <img src="../../../assets/img/document.svg" alt="" />
                        <div class="pl-2">
                          <div class="pcs-doc-title">{{ doc.label }}</div>
                          <span>(Accepted on {{ doc.updatedAt }})</span>
                        </div>
                      </section>
                      <section>
                        <img
                          class="pointer mr-2"
                          @click="selectSingleDoc(doc)"
                          src="../../../assets/talentpool/blueEye.svg"
                          alt=""
                        />
                      </section>
                    </article>
                  </div>
                  <div v-else class="p-3">
                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-center
                        w-100
                      "
                    >
                      <div class="d-flex align-items-center w-80">
                        <img
                          @click="selectedDoc = null"
                          class="pointer"
                          src="../../../assets/img/feedbackform/backarrow.svg"
                          alt=""
                        />
                        <span class="newJD-heading mx-3 text-truncate">{{
                          selectedDoc.label
                        }}</span>
                        <div
                          ref="close-job"
                          v-if="
                            selectedDoc.allowMultiple && selectedDoc.multiFields
                          "
                        >
                          <img
                            @click="showMultiDocs = !showMultiDocs"
                            :class="showMultiDocs && 'pcs-arrow'"
                            class="pointer"
                            src="../../../assets/img/newkanban/downsmallarrow.svg"
                            alt=""
                          />
                          <div
                            v-if="showMultiDocs"
                            class="kanban-job-dd pcs-doc-dropdown"
                            ref="select-job"
                            v-closable="{
                              exclude: ['close-job', 'select-job'],
                              handler: 'closeJobCard',
                            }"
                          >
                            <div
                              class="text-truncate"
                              @click="selectMultiDoc(subdoc, index)"
                              :class="
                                selectedDoc.selectedIndex.startsWith(index)
                                  ? 'kanban-job-dd-active'
                                  : 'kanban-job-dd-inactive'
                              "
                              v-for="(subdoc, index) in selectedDoc.multiFields"
                              :key="subdoc.label + index"
                            >
                              <!-- v-b-tooltip.hover.bottom="subdoc.label" -->
                              <span>{{ index + 1 }}. {{ subdoc.label }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="w-20 text-right">
                        <img
                          class="pointer"
                          v-b-tooltip.hover.bottom="'Download'"
                          @click="downloadOnboardLink(getSelectedLink())"
                          src="../../../assets/talentpool/download.svg"
                          alt=""
                        />
                      </div>
                    </div>
                    <template
                      v-if="getFileTypeImg(getSelectedLink())[0] == 'pdf'"
                    >
                      <div
                        class="
                          d-flex
                          justify-content-center
                          pcs-doc-overflow
                          invisible-scroll
                        "
                      >
                        <div class="w-70 pcs-doc-shadow">
                          <pdf
                            class="h-100 w-100 viewReseme-canvas"
                            ref="pdf"
                            :src="getSelectedLink()"
                            :page="currentPage"
                            @num-pages="numPages = $event"
                            @link-clicked="currentPage = $event"
                            @page-loaded="currentPage = $event"
                          ></pdf>
                        </div>
                      </div>
                      <div
                        class="
                          viewResume-paginaTion-modal
                          align-items-center
                          justify-content-center
                          d-flex
                          w-100
                        "
                      >
                        <div class="pagination">
                          <b-pagination
                            align="center"
                            first-number
                            last-number
                            v-model="currentPage"
                            :total-rows="numPages"
                            :per-page="perPage"
                          >
                            <template #prev-text>
                              <span>
                                <img
                                  src="../../../assets/img/accessconnew/pageleft.svg"
                                  alt
                                />
                              </span>
                            </template>
                            <template #next-text>
                              <span>
                                <img
                                  src="../../../assets/img/accessconnew/pageright.svg"
                                  alt
                                />
                              </span>
                            </template>
                          </b-pagination>
                        </div>
                      </div>
                    </template>
                    <div
                      v-else
                      class="
                        d-flex
                        justify-content-center
                        align-items-center
                        pcs-doc-overflow
                      "
                    >
                      <div class="ondoc-word-resume">
                        <div class="text-center">
                          <img
                            :src="getFileTypeImg(getSelectedLink())[1]"
                            alt
                          />
                        </div>
                        <div
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                            mt-2
                          "
                        >
                          <div
                            class="
                              newCand-word-resume-font
                              text-truncate text-right
                              w-100
                              text-center
                            "
                          >
                            {{ getFileNameFromLink(getSelectedLink()) }}
                          </div>
                        </div>
                        <div class="slating-sub-text">
                          Download the document to view it
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </b-sidebar>
    </div>
    <ViewResume
      v-if="viewResume"
      :label="previewLabel"
      :showModal="viewResume"
      :link="previewLink"
      @close-modal="viewResume = false"
    />
    <previewImage
      v-if="viewImage"
      :label="previewLabel"
      :showModal="viewImage"
      :link="previewImgLink"
      @close-modal="viewImage = false"
    />
    <PreviewFeedback
      v-if="singleFeedbackModal"
      :candidateData="candidateData"
      :selectedRound="singleFeedbackData.feedBackForm.customFeedback"
      :allData="singleFeedbackData"
      :basicCandInfo="singleBasicInfo"
      :ipmodal="singleFeedbackModal"
      :showScreenshot="true"
      @storeCandidateData="storeCandData"
      @closeModal="closeSingleFeedbackModal"
    />
    <ViewAssessment
      v-if="showViewAssessment"
      :showModal="showViewAssessment"
      :testValue="testData"
      @close-modal="(showViewAssessment = false), (testData = {})"
    />
    <ViewCVS
      v-if="showCVSModal"
      :showModal="showCVSModal"
      :cvsData="singleCandCVS"
      @close-modal="showCVSModal = false"
    />
    <ViewAssessMarks
      v-if="showMarksModal"
      :showModal="showMarksModal"
      :testData="testData"
      @close-modal="(showMarksModal = false), (testData = {})"
    />
  </div>
</template>

<script>
import {
  getTalentPoolCandidate,
  getNotes,
  getResume,
  getResumeReport,
  getCandidateJobHistory,
  // getCandidateSummary,
  downloadAnyFile,
  getcandidateVendorJd,
  trigerCvs,
  getCandScreeningData,
  getCandOnboardingDocs,
  getFeedbackHistory,
  getHistoryHtml,
  converterAtsPreview,
  getProtfolioLink,
  getPanelFeedbacks,
} from "../../../utils/apiFunctions";
import { PDFDocument } from "pdf-lib";
import { DateTime } from "luxon";
import pdf from "vue-pdf";
import ViewResume from "../../../components/modals/viewResume.vue";
import PreviewFeedback from "../../../views/InterviewProcess/PreviewFeedback.vue";
import EventBus from "../../../utils/eventBus";
import { downloadResumeFile } from "../../../utils/download.js";
import {
  checkFieldKeys,
  isHtmlContent,
  checkValuesOfKey,
  fileType,
} from "../../../utils/customFields";
import PreviewImage from "../../../components/Kanban/modal/PreviewImageModal.vue";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import toast from "../../../components/mixin/toast";
import { mapGetters } from "vuex";
import PdfSearch from "../../../components/fixedcomponents/PdfSearch.vue";
import InputField from "../../../components/InputComponents/Input";
import ViewAssessment from "../../../components/Kanban/modal/ViewAssessment.vue";
import ViewCVS from "../../../components/Kanban/modal/ViewCVS.vue";
import ViewAssessMarks from "../../../components/Kanban/modal/ViewAssessMarks.vue";
import {
  convertDateFormat,
  getFileType,
} from "../../../controllers/commonHelpers";
import CVSPreview from "../../../components/PreviewCandidateSidebar/CVSPreview.vue";
import CVSPreviewMixin from "../../../components/mixin/CVSPreviewMixin";

export default {
  name: "PreviewCandidateSidebar",
  mixins: [toast, CVSPreviewMixin],
  data() {
    return {
      currentType: "recent",
      searchText: "",
      reportSearchText: "",
      selectedJobInd: null,
      historyLoading: false,
      noteLoading: false,
      showMultiDocs: false,
      showDocuments: false,
      LoaderStatus: false,
      selectedCvsIndex: 0,
      selectedDate: null,
      showCard: false,
      currentPage: 1,
      numPages: 0,
      perPage: 1,
      tabIndex: 0,
      selectedDoc: null,
      historyRound: null,
      documentData: [],
      testData: {},
      screeningSel: {},
      candidateData: {},
      candidateStatus: {},
      particularJob: {
        upcomingRounds: [],
        interviewProcess: [],
      },
      screeningData: [],
      selectedJob: {},
      singleCandCVS: {},
      singleFeedbackData: {},
      singleBasicInfo: {},
      jobHistory: [],
      notes: {
        recent: [],
        category: [],
      },
      previewLink: null,
      previewLabel: null,
      previewImgLink: null,
      intervalId: null,
      viewImage: false,
      showSpinner: false,
      jobHistoryLoading: false,
      viewResume: false,
      singleFeedbackModal: false,
      resumeLoading: false,
      downloadingJob: null,
      vendor: false,
      showScreeningTab: false,
      showViewAssessment: false,
      showCVSModal: false,
      showMarksModal: false,
      resume: {
        type: "",
        link: null,
      },
      reportLink: null,
      reportLoading: false,
    };
  },
  components: {
    pdf,
    ViewResume,
    PreviewFeedback,
    PreviewImage,
    Loader,
    PdfSearch,
    InputField,
    ViewAssessment,
    ViewCVS,
    ViewAssessMarks,
    CVSPreview,
  },
  props: {
    showActivate: Boolean,
    showModal: Boolean,
    candidateID: String,
    selectedCandidate: Object,
    customFieldsArray: Array,
    kanbanLevel: String,
    shared: Boolean,
    showNote: Boolean,
    jobOnHold: Boolean,
    singleJob: Object,
    openReportTab: { type: Boolean, default: false },
    showNoteTag: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    if (this.showNoteTag) this.tabIndex = 1;
    if (this.openReportTab) {
      this.tabIndex = 3;
    }
    if (this.selectedCandidate.reportKey) {
      this.getReport();
    }
    if (this.$route.name == "VendorKanban") {
      this.vendor = true;
      if (this.candAddedToJob) await this.getCandidateStatusDetails();
    }
    await this.getCandidateData();
    if (!this.vendor && !this.roles.includes("GET_VENDOR_DASHBOARD")) {
      await this.getCandScreeningData();
      await this.getCandOnboardingDocs();
    }
  },
  mounted() {
    EventBus.$on("notes-added", this.noteUpdate);
  },
  computed: {
    ...mapGetters(["roles"]),
    ...mapGetters("userVUEX", {
      projectUsers: "getProjectUsers",
      vendorID: "getVendorID",
    }),
    ...mapGetters("jobDescriptionVUEX", {
      storedData: "getSelectedCandidate",
    }),
    showProfile() {
      if (this.vendor || this.roles.includes("GET_VENDOR_DASHBOARD"))
        return true;
      else return this.roles.includes("GET_PROFILE");
    },
    fromRecKanban() {
      return this.$route.name == "Kanban";
    },
    getCvsDates() {
      return this.candidatecvsdata.map((data, index) => {
        const timeValue = data.stats?.timing?.endTime || data.createdAt;
        const date = DateTime.fromISO(timeValue, { zone: "utc" })
          .setZone("Asia/Kolkata")
          .toFormat("dd MMM, yy, hh:mm a");
        // Use the list index as the option value so selection maps 1:1 to the
        // CVS row (index is guaranteed valid and avoids id-matching mismatches).
        return { text: date, value: index };
      });
    },
    formattedCreatedAt() {
      let createadAt = this.candidateData.createdAt;
      if (createadAt) {
        const createdAt = this.candidateData.createdAt.substring(0, 10);
        return this.convertDateToDDMMYYYY(createdAt);
      }
      return null;
    },
    getDocsRejRec() {
      if (this.vendor && this.selectedCandidate.documentStatus != null) {
        if (
          this.selectedCandidate.customerID[this.$route.query.customerID] &&
          this.selectedCandidate.customerID[this.$route.query.customerID][
            this.$route.query.jobID
          ].documentRejectedByRecruiter != null
        ) {
          return this.selectedCandidate.customerID[
            this.$route.query.customerID
          ][this.$route.query.jobID].documentRejectedByRecruiter;
        }
      }
      return false;
    },
    candidateDocsUploaded() {
      return !(
        this.selectedCandidate.kanbanLevel == "P" && this.checkIfCandPushed
      );
    },
    checkIfCandPushed() {
      if (this.selectedCandidate.documentStatus == null) {
        return this.selectedCandidate.pushed;
      } else {
        return (
          !this.selectedCandidate.customerID[this.singleJob.customerID][
            this.singleJob.jobID
          ].documentRejectedByRecruiter && this.selectedCandidate.pushed
        );
      }
    },
    getDocImage() {
      if (this.particularJob.documentStatus === 0) {
        return require("@/assets/new-icons/doc-rejected.svg");
      } else if ([1, 5].includes(this.particularJob.documentStatus)) {
        return require("@/assets/new-icons/accepted-docs.svg");
      } else if ([2, 4].includes(this.particularJob.documentStatus)) {
        return require("@/assets/new-icons/uploaded-docs.svg");
      }
      return require("@/assets/new-icons/req-docs.svg");
    },
    getDocTitle() {
      if (this.particularJob.documentStatus === 0) {
        return "Documents Rejected";
      } else if ([1, 5].includes(this.particularJob.documentStatus)) {
        return "Documents Accepted";
      } else if ([2, 4].includes(this.particularJob.documentStatus)) {
        return "Documents Uploaded";
      }
      return "Documents Requested";
    },
    candAddedToJob() {
      return Object.keys(this.selectedCandidate).includes("kanbanLevel");
    },
    getUserName() {
      let id = this.candidateData.createdBy;
      let value =
        this.projectUsers[id] && this.projectUsers[id].username
          ? this.projectUsers[id].username
          : null;
      return value;
    },
    formattedUsername() {
      return this.getUserName.replace(/\b\w/g, (char) => char.toUpperCase());
    },
    showDownload() {
      if (this.vendor || this.roles.includes("GET_VENDOR_DASHBOARD"))
        return this.selectedJob.dossier;
      return true;
    },
  },
  filters: {
    // formatTimestamp(timestamp) {
    //   const date = new Date(timestamp);
    //   const day = date.getDate();
    //   const month = date.toLocaleString("default", { month: "long" });
    //   const year = String(date.getFullYear()).slice(-2);
    //   const hours = date.getHours() % 12 || 12;
    //   const minutes = String(date.getMinutes()).padStart(2, "0");
    //   const ampm = date.getHours() >= 12 ? "PM" : "AM";
    //   const ordinalSuffix = (n) =>
    //     n +
    //     (n % 10 === 1 && n % 100 !== 11
    //       ? "st"
    //       : n % 10 === 2 && n % 100 !== 12
    //       ? "nd"
    //       : n % 10 === 3 && n % 100 !== 13
    //       ? "rd"
    //       : "th");
    //   return `(${ordinalSuffix(
    //     day
    //   )} ${month}, ${year}, ${hours}:${minutes} ${ampm})`;
    // },
  },
  watch: {
    historyLoading(val) {
      if (!val) this.downloadingJob = null;
    },
    selectedCvsIndex() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      if (this.candidatecvsdata.length !== 0) {
        this.checkAndStartCVS();
      }
    },
  },

  methods: {
    async getReport() {
      if (this.reportLink || this.reportLoading || !this.singleJob) return;
      this.reportLoading = true;
      try {
        const res = await getResumeReport({
          candidateID: this.candidateID,
          customerID: this.singleJob.customerID,
          jobID: this.singleJob.jobID,
        });
        this.reportLink = res.data.data.reportLink || null;
      } catch (error) {
        this.reportLink = null;
      } finally {
        this.reportLoading = false;
      }
    },
    verdictLabel(rec) {
      if (rec.fit) return rec.fit.band;
      const map = { ADVANCE: "Strong Fit", HOLD: "Review", REJECT: "No Fit" };
      return (rec && map[rec.decision]) || "View Report";
    },
    verdictColor(rec) {
      const token = rec && rec.fit && rec.fit.token;
      if (token) {
        const tokenColors = {
          good: "#038e00",
          warn: "#ffc145",
          crit: "#eb0002",
          neu: "#5a6472",
        };
        return `color: ${tokenColors[token] || "#5a6472"}`;
      }
      const decision = rec && rec.decision;
      if (decision === "ADVANCE") return "color: #038e00";
      if (decision === "REJECT") return "color: #eb0002";
      return "color: #ffc145";
    },
    convertDateFormat(dateStr) {
      return convertDateFormat(dateStr);
    },
    showOnboardedDate(round) {
      return round.movementType == "16" && round.onboardingDate;
    },
    storeCandData() {
      let candData = {
        candidate: this.selectedCandidate,
        selectedJob: this.selectedJob,
        round: this.historyRound,
      };
      this.$store.commit("jobDescriptionVUEX/setSelectedCandidate", candData);
    },
    assessSubEval(round) {
      return round.movementType == "31" && round.showViewMarks;
    },
    historyError() {
      this.historyLoading = false;
      this.errorModal("Something went wrong!");
    },
    stripHtmlTags(html) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || "";
    },
    async getProtfolioLink(jobID, html) {
      try {
        const res = await getProtfolioLink({
          candidateID: this.candidateData.candidateID,
        });
        if (res.status == 200) {
          this.downloadHistory(jobID, html, res.data.data.profileLink);
        } else {
          this.historyError();
        }
      } catch (error) {
        this.historyError();
        console.error(error);
      }
    },
    async getHistoryHtml(jobID, html) {
      try {
        let form = new FormData();
        form.append("jobID", jobID);
        form.append("candidateID", this.candidateData.candidateID);
        form.append("html", html);
        if (this.vendor || this.roles.includes("GET_VENDOR_DASHBOARD")) {
          form.append("vendorID", this.$route.params.vendorID || this.vendorID);
        }
        const res = await getHistoryHtml(form);
        if (res.status == 200) {
          this.getProtfolioLink(jobID, res.data);
          // this.downloadHistory(res.data);
        } else {
          this.historyError();
        }
      } catch (error) {
        this.historyError();
        console.error(error);
      }
    },
    async downloadHistory(jobID, html, link) {
      try {
        const blob = new Blob([html], {
          type: "text/html",
        });
        const formData = new FormData();
        formData.append("htmlFile", blob);
        formData.append("returnType", "pdf");
        formData.append("outputPath", `${this.candidateData.name}`);
        formData.append("profileLink", link);
        formData.append("type", "dossier");
        const res = await converterAtsPreview(formData);
        if (res.status == 200) {
          this.getPanelFeedbacks(jobID, res.data);
        } else {
          this.historyError();
        }
      } catch (error) {
        this.historyError();
        console.error(error);
      }
    },
    async getPanelFeedbacks(jobID, urls) {
      try {
        let payload = {
          candidateID: this.candidateData.candidateID,
          jobID: jobID,
        };
        const res = await getPanelFeedbacks(payload);
        if (res.status == 200) {
          let urlData = [urls];
          if (res.data.data.feedbacks.length != 0) {
            const blobs = await Promise.all(
              res.data.data.feedbacks.map((u) => fetch(u).then((r) => r.blob()))
            );
            urlData = [...urlData, ...blobs];
            this.mergeFromUrls(urlData);
          } else this.mergeFromUrls(urlData);
        } else {
          this.historyError();
        }
      } catch (error) {
        this.historyError();
        console.error(error);
      }
    },
    async mergeFromUrls(urls) {
      try {
        const merged = await this.mergePDFBlobs(urls);
        this.download(merged, `${this.candidateData.name}.pdf`);
      } catch (e) {
        this.historyError();
        console.error(e);
      }
    },
    download(blob, filename) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
      this.historyLoading = false;
    },
    async mergePDFBlobs(blobArray) {
      const mergedPdf = await PDFDocument.create();

      for (const blob of blobArray) {
        try {
          const arrayBuffer = await blob.arrayBuffer();
          const pdf = await PDFDocument.load(arrayBuffer);
          const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
          pages.forEach((p) => mergedPdf.addPage(p));
        } catch (error) {
          continue;
        }
      }
      const mergedBytes = await mergedPdf.save();
      return new Blob([mergedBytes], { type: "application/pdf" });
    },
    autoCancelName(round) {
      let text =
        round.cancelledBy == 2
          ? "Hire3x Panelist"
          : round.cancelledBy == 3
          ? "Candidate"
          : "Hire3x Automated";
      return text;
    },
    formatUTCToIST(dateStr) {
      const utcDate = new Date(dateStr);

      // Convert to IST by adding 5 hours and 30 minutes
      const istOffsetMs = 5.5 * 60 * 60 * 1000;
      const istDate = new Date(utcDate.getTime() + istOffsetMs);

      const day = istDate.getDate();
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const month = monthNames[istDate.getMonth()];
      const year = String(istDate.getFullYear()).slice(-2);

      let hours = istDate.getHours();
      const minutes = istDate.getMinutes().toString().padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;

      const getDaySuffix = (d) => {
        if (d >= 11 && d <= 13) return "th";
        switch (d % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      };

      return `${day}${getDaySuffix(
        day
      )} ${month},${year}, ${hours}:${minutes} ${ampm}`;
    },
    getAlrdyIntText(round) {
      if (typeof round.toInterviewRound == "string") {
        let roundText = this.getStatusText(round.toInterviewRound);
        return `From Round ${round.fromInterViewRound} to ${roundText}`;
      } else
        return `From Round ${round.fromInterViewRound} to Round ${round.toInterviewRound}`;
    },
    async getFeedBack(round) {
      try {
        const res = await getFeedbackHistory({
          interviewID: round.interviewID,
          jobID: round.jobID,
          candidateID: round.candidateID,
        });
        if (res.status == 200) {
          this.singleFeedbackData = res.data.data[0];
          this.singleBasicInfo = {};
          this.singleBasicInfo["name"] = this.singleFeedbackData.name;
          this.singleBasicInfo["evalDate"] =
            this.singleFeedbackData.feedBackForm.createdAt;
          this.singleBasicInfo["panel"] =
            this.singleFeedbackData.feedBackForm.panelName;
          this.singleBasicInfo["modeOfInterview"] =
            round.interviewType || round.type;
          this.singleBasicInfo["action"] =
            this.singleFeedbackData.feedBackForm.recommendation;
          this.singleBasicInfo["remarks"] =
            this.singleFeedbackData.feedBackForm.recruiterRemarks;
          this.singleBasicInfo["feedback"] =
            this.singleFeedbackData.assessmentResponse;
          this.historyRound = round;
          this.singleFeedbackModal = true;
        }
      } catch (error) {
        console.error(error);
      }
    },
    getStatusText(rec) {
      if (rec == "R") {
        return "Rejected";
      } else if (rec == "H") {
        return "On hold";
      } else if (rec == "NI") {
        return "Not Interested";
      } else {
        return "Selected";
      }
    },
    convertDateTime(input) {
      const date = new Date(input.replace(" ", "T"));

      const day = date.getDate();
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear().toString().slice(-2);

      const hour24 = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const ampm = hour24 >= 12 ? "PM" : "AM";
      const hour12 = hour24 % 12 || 12;

      // Ordinal suffix for day
      const ordinalSuffix = (d) => {
        if (d > 3 && d < 21) return "th";
        switch (d % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      };

      return `${day}${ordinalSuffix(
        day
      )} ${month},${year}, ${hour12}:${minutes} ${ampm}`;
    },
    getDocSrc(round) {
      if (round.movementType == 36) {
        return require("../../../assets/img/newkanban/doc-req.svg");
      } else if (round.movementType == 40) {
        return require("../../../assets/img/newkanban/doc-review.svg");
      } else if (round.movementType == 38) {
        return require("../../../assets/img/newkanban/doc-acpt.svg");
      } else if (round.movementType == 39) {
        return require("../../../assets/img/newkanban/doc-reject.svg");
      } else if (round.movementType == 37) {
        return require("../../../assets/img/newkanban/doc-sub.svg");
      }
    },
    showSameLineSub(round) {
      return ["19", "20", "21", "22", "15", "16", "2"].includes(
        round.movementType
      );
    },
    getSelectedAssess(id) {
      return this.singleJob.interviewProcess.process.find((obj) => obj.id == id)
        .config;
    },
    showButton(round) {
      return (
        round.historyType == 4 ||
        ["25", "26", "27", "29", "11", "32"].includes(round.movementType) ||
        this.assessSubEval(round)
      );
    },
    buttonText(round) {
      let text;
      if (round.movementType == "11") text = "View Assessment";
      else if (round.movementType == "32" || this.assessSubEval(round))
        text = "View Marks";
      else if (round.movementType == "25") text = "Review Documents";
      else if (
        ["26", "27"].includes(round.movementType) ||
        round.historyType == 4
      )
        text = "View Documents";
      else if (round.movementType == "29") text = "View CVS";
      return text;
    },
    checkAndApply(round) {
      // this.showViewAssessment = true;
      if (round.historyType == 4) this.gotoFinalDocs();
      if (
        ["32", "11"].includes(round.movementType) ||
        this.assessSubEval(round)
      ) {
        this.testData = {
          emailID: round.email || round.emailID,
          testID: round.testID,
          groupID: round.groupID,
          attemptNo: round.attemptNo || 1,
        };
      }
      if (round.movementType == "32" || this.assessSubEval(round))
        this.showMarksModal = true;
      else if (round.movementType == "11") this.showViewAssessment = true;
      else if (["25", "26", "27"].includes(round.movementType)) {
        let view = ["26", "27"].includes(round.movementType) ? true : false;
        this.goToViewDocs(view);
      } else if (round.movementType == "29") {
        if (round.uuid)
          this.singleCandCVS = this.candidatecvsdata.find(
            (obj) => obj.uuid == round.uuid
          );
        else this.singleCandCVS = this.candidatecvsdata[0];
        this.showCVSModal = true;
      }
    },
    goToViewDocs(viewVal) {
      let query = {
        jobID: this.selectedJob.jobID || this.$route.query.jobID,
        candidateID: this.candidateID,
        from: this.$route.name,
        view: viewVal,
      };
      if (this.vendor) {
        query.vendorID = this.$route.params.vendorID;
        query.client = this.$route.params.client;
      } else {
        query.customerID = this.$route.query.customerID;
      }
      this.$router.push({
        name: "viewRequiredCandidateDocs",
        query,
      });
    },
    setNotesID() {
      const container = this.$refs.noteTabs?.$el;
      if (container) {
        const tabContent = container.querySelector(".tab-content");
        if (tabContent) {
          tabContent.id = "noteTag";
        }
      }
    },
    showAddNote(typeVal) {
      let noteData = {
        type: typeVal,
        tags: [],
      };
      if (
        this.candidateData.customFields.notesTags &&
        this.candidateData.customFields.notesTags.length != 0
      ) {
        noteData.tags = this.candidateData.customFields.notesTags;
      }
      this.$emit("add-note", noteData);
    },
    checkAndStartCVS() {
      if (
        this.candidatecvsdata[this.selectedCvsIndex].stats?.videoProcessed ==
        false
      ) {
        this.intervalId = setInterval(() => {
          if (
            this.candidatecvsdata[this.selectedCvsIndex].stats
              ?.videoProcessed === false
          ) {
            this.getCVSData();
          } else {
            clearInterval(this.intervalId);
          }
        }, 30000);
      }
    },
    scrollTop(refVal) {
      if (document.getElementById(refVal) != null) {
        let element = document.getElementById(refVal);
        element.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },

    videoProcessed(cvs) {
      if (cvs.stats) return cvs.stats.videoProcessed;
      else return true;
    },
    gotoFinalDocs() {
      this.$router.push({
        name: "OnboardingDocuments",
        params: {
          jobID: this.selectedJob.jobID,
          candidateID: this.candidateID,
        },
        query: this.$route.query,
      });
    },
    closeJobCard() {
      this.showMultiDocs = false;
    },
    getFileTypeImg(fileUrl) {
      return getFileType(fileUrl);
    },
    downloadOnboardLink(link) {
      const a = document.createElement("a");
      a.href = link;
      a.click();
    },
    getSelectedLink() {
      if (this.selectedDoc.multiFields) {
        return this.selectedDoc.multiFields[
          this.selectedDoc.selectedIndex.split("-")[0]
        ].link;
      } else {
        return this.selectedDoc?.uploadedFiles[0];
      }
    },
    selectMultiDoc(doc, index) {
      this.selectedDoc.selectedIndex = `${index}-${doc.label}`;
      this.showMultiDocs = false;
      this.$forceUpdate();
    },
    selectSingleDoc(doc) {
      this.selectedDoc = doc;
      if (doc.multiFields) this.selectedDoc.selectedIndex = `0-${doc.label}`;
      this.$forceUpdate();
    },
    async getCandOnboardingDocs() {
      try {
        const res = await getCandOnboardingDocs({
          candidateID: this.candidateID,
        });
        if (res.status == 200) {
          this.showDocuments = true;
          this.documentData = res.data.data[0].fields;
          this.documentData.map((obj) => {
            if (obj.allowMultiple && obj.uploadedFiles?.length > 1) {
              obj.multiFields = this.getMultiFieldData(obj);
            }
            return obj;
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    getMultiFieldData(doc) {
      let totalArr = [];
      for (let [index, i] of doc.uploadedFiles.entries()) {
        let eachVal = {
          label: decodeURIComponent(i.split("/").pop().split(".")[0]),
          link: doc.uploadedFiles[index],
        };
        totalArr.push(eachVal);
      }
      return totalArr;
    },
    formatDateTime(dateString) {
      const date = new Date(dateString);

      const time = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      const weekday = date.toLocaleDateString("en-US", {
        weekday: "short",
      });

      const datePart = date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      });

      return `${time} ${weekday}, ${datePart}`;
    },

    getRecValue(value) {
      if (value == "SS") return "Strongly Selected";
      else if (value == "S") return "Selected";
      else if (value == "SR") return "Strongly Rejected";
      else if (value == "R") return "Rejected";
    },
    getSubmittedName(id) {
      return this.projectUsers[id].username.replace(/\b\w/g, (char) =>
        char.toUpperCase()
      );
    },
    handleCloseDateDropdown() {
      this.showCard = false;
    },
    async reTriggerCvs() {
      this.LoaderStatus = true;
      try {
        let payload = {
          candidates: [this.candidateID],
        };
        if (this.$route.name == "Kanban" && this.$route.query.jobID) {
          payload.jobID = this.$route.query.jobID;
        }
        const response = await trigerCvs(payload);
        if (response.status == 200) {
          this.successModal("Successfully triggered.");
        } else {
          throw new Error();
        }
      } catch (error) {
        console.error(error);
        this.errorModal("Something went wrong!");
      } finally {
        this.LoaderStatus = false;
      }
    },

    changeCvsPreview(selectedValue) {
      // selectedValue is the list index emitted by the radio group options.
      this.selectedCvsIndex = selectedValue;
      this.showCard = false;
    },
    async getCandScreeningData() {
      try {
        let payload = {
          candidateID: this.candidateID,
        };
        if (this.fromRecKanban) payload.jobID = this.$route.query.jobID;
        const res = await getCandScreeningData(payload);
        if (res.status == 200) {
          this.screeningData = res.data.data;
          if (res.data.data.length != 0) this.showScreeningTab = true;
        }
      } catch {
        console.error("error");
      }
    },
    async getCVSData() {
      this.fetchCVSPreview(this.candidateID);
    },
    async getCandidateData(from) {
      this.resumeLoading = true;

      let vendor = false;
      if (this.vendor || this.roles.includes("GET_VENDOR_DASHBOARD")) {
        vendor = true;
      }
      const res = await getTalentPoolCandidate("2", this.candidateID, vendor);
      if (res.status == 200) {
        this.candidateData = res.data.data[0];
        if (!from) {
          this.candidateJobHistory();
        }
      }
      if (!from) {
        this.getNotes("recent");
        this.getCVSData();
        const resumeResponse = await getResume({
          candidateID: this.candidateData.candidateID,
        });
        this.resumeLoading = false;

        this.resume.link = resumeResponse.data.data.resumeLink;
      }
    },
    async getNotes(type) {
      this.noteLoading = true;
      this.currentType = type;
      let payload = {
        candidateID: this.candidateID,
        version: "v2",
      };
      if (type == "category") {
        payload.jobID = this.$route.query.jobID;
      }
      if (type == "category") payload.sortBy = "category";
      const notes = await getNotes(payload);
      if (notes.status == 200) {
        this.notes[type] = notes.data.data;
      }
      this.noteLoading = false;
      this.$forceUpdate();
    },
    async getCandidateStatusDetails() {
      try {
        let payload = {
          candidateID: this.candidateID,
          jobID: this.$route.query.jobID,
        };
        const res = await getcandidateVendorJd(payload);
        if (res.status == 200) {
          this.candidateStatus = res.data.data;
        }
      } catch (err) {
        console.error(err);
      }
    },
    checkFieldKeys(field) {
      return checkFieldKeys(field, this.candidateData);
    },
    isHtmlContent(field) {
      return isHtmlContent(field, this.candidateData);
    },
    checkValuesOfKey(field) {
      return checkValuesOfKey(field, this.candidateData);
    },
    getFileIcon(field) {
      let filename = this.checkValuesOfKey(field);
      let fileExtension = this.getFileType(filename);

      return fileType(fileExtension);
    },
    getFileType(filename) {
      let lastIndexImage = filename.lastIndexOf("/");
      let someImage = filename.substring(lastIndexImage + 1);
      let imagename = someImage.split("?")[0];
      const fileExtension = imagename.split(".").pop().toLowerCase();
      return fileExtension;
    },
    convertDateToDDMMYYYY(date) {
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    closemodal() {
      this.$emit("close-view-icon", this.showNoteTag);
      if (this.$route.query.history) {
        this.$store.commit("jobDescriptionVUEX/setSelectedCandidate", "");
        let newQuery = { ...this.$route.query };
        delete newQuery.history;
        delete newQuery.round;
        delete newQuery.candidateID;
        this.$router.replace({ path: this.$route.path, query: newQuery });
      }
    },
    async candidateJobHistory() {
      try {
        this.jobHistoryLoading = true;
        let payload = {
          candidateID: this.candidateData.candidateID,
          version: "v2",
        };
        if (this.vendor || this.roles.includes("GET_VENDOR_DASHBOARD")) {
          payload.vendor = true;
          payload.vendorID = this.$route.params.vendorID || this.vendorID;
        }
        const res = await getCandidateJobHistory(payload);
        if (res.status == 200) {
          this.showSpinner = false;
          if (res.data.data.length != 0) {
            this.jobHistory = this.repositionCurrentJob(
              JSON.parse(JSON.stringify(res.data.data[0].jobInfo))
            );
            if (
              this.storedData &&
              (this.$route.query.history || this.$route.query.preview)
            ) {
              this.selectedJob = this.storedData.selectedJob;
              this.selectedJobInd = this.jobHistory.findIndex(
                (obj) => obj.jobID == this.selectedJob.jobID
              );
              await this.particularJobHistory();
              setTimeout(() => {
                this.scrollToJob();
                this.$store.commit(
                  "jobDescriptionVUEX/setSelectedCandidate",
                  ""
                );
              }, 250);
              if (!this.$route.query.preview) {
                this.getFeedBack(this.storedData.round);
              }
            } else {
              this.selectedJobInd = 0;
              this.selectedJob = this.jobHistory[0];
              this.particularJobHistory();
            }
          }
        }
        this.jobHistoryLoading = false;
      } catch (err) {
        console.error(err);
        this.showSpinner = false;
      }
    },
    repositionCurrentJob(jobs) {
      const index = jobs.findIndex(
        (job) => job.jobID === this.$route.query.jobID
      );
      if (index !== -1) {
        const [currentJob] = jobs.splice(index, 1);
        jobs.unshift(currentJob);
      }
      return jobs;
    },
    async toggleCollapse(job, index) {
      // this.selectedJob = {};
      if (this.selectedJob.jobID === job.jobID) {
        this.selectedJob = {};
        this.selectedJobInd = null;
      } else {
        this.selectedJob = job;
        this.selectedJobInd = index;
        await this.particularJobHistory();
        setTimeout(() => {
          this.scrollToJob();
        }, 250);
      }
    },
    scrollToJob() {
      let id = "jobhistory" + this.selectedJob.jobID;
      if (document.getElementById(id) != null) {
        let element = document.getElementById(id);
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    toggleCollapseScreening(screening) {
      if (this.screeningSel._id === screening._id) {
        this.screeningSel = {};
      } else {
        this.screeningSel = screening;
      }
    },
    isDocType(fileUrl) {
      return fileUrl == null
        ? false
        : fileUrl
            .substring(fileUrl.lastIndexOf("/") + 1)
            .split("?")[0]
            .toLowerCase()
            .endsWith(".doc") ||
            fileUrl
              .substring(fileUrl.lastIndexOf("/") + 1)
              .split("?")[0]
              .toLowerCase()
              .endsWith(".docx");
    },
    getFileName(fileName) {
      if (fileName.length <= 30) {
        return fileName;
      } else {
        return fileName.slice(0, 30) + "...";
      }
    },
    noteUpdate() {
      this.getCandidateData("notadded");
      this.particularJobHistory();
      this.getNotes("recent");
      this.getNotes("category");
      if (!this.roles.includes("GET_VENDOR_DASHBOARD"))
        this.$emit("get-cand-data");
    },
    async particularJobHistory() {
      this.particularJob = [];
      this.particularJobLoading = true;
      let payload = {
        candidateID: this.candidateData.candidateID,
        jobID: this.selectedJob.jobID,
        type: "2",
        customerID: this.selectedJob.customerID,
        version: this.selectedJob.jobHistoryVersion,
      };
      if (this.vendor || this.roles.includes("GET_VENDOR_DASHBOARD")) {
        payload.vendor = true;
        payload.vendorID = this.$route.params.vendorID || this.vendorID;
      }
      const res = await getCandidateJobHistory(payload);
      if (res.status === 200) {
        let interviewProcess =
          this.selectedJob.jobHistoryVersion == "v3"
            ? res.data.data
            : res.data.data.interviewProcess;
        if (this.selectedJob.jobHistoryVersion == "v2") {
          this.particularJob = res.data.data;
          if (this.roles.includes("GET_VENDOR_DASHBOARD")) {
            this.particularJob.interviewProcess = interviewProcess.filter(
              (obj) => {
                if (obj.historyType == 3 && !obj.state) {
                  return;
                } else return obj;
              }
            );
          }
        } else this.particularJob.interviewProcess = res.data.data;
        let lastIndex;
        if (this.selectedJob.jobHistoryVersion == "v3") {
          this.particularJob.interviewProcess.map((obj, index) => {
            if (obj.type == "onboardingDocs") lastIndex = index;
          });
        } else {
          this.particularJob.interviewProcess.map((obj, index) => {
            if (obj.historyType == 4) lastIndex = index;
          });
        }
        if (lastIndex)
          this.particularJob.interviewProcess[lastIndex].showDocs = true;
        this.particularJob.interviewProcess =
          this.particularJob.interviewProcess.map((obj) => {
            if (obj.type == "onboardingDocs" && obj.remarks)
              obj.remarks = this.stripHtmlTags(obj.remarks);
            return obj;
          });
      }
      this.particularJobLoading = false;
      this.$forceUpdate();
    },
    async downloadLink(link, type) {
      if (type === "resume") {
        await downloadResumeFile(link, this.candidateData.name);
        return;
      }
      const candidateName = this.candidateData.name;
      let fileName;
      if (type === "report") {
        fileName = `${candidateName}'s Match Report.pdf`;
      } else {
        fileName = this.getFileNameFromLink(link);
      }
      const response = await fetch(link);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(blobUrl);
    },
    handlePageLoaded(pageNumber) {
      this.currentPage = pageNumber;
      const viewerElement = this.$refs.pdf.$el;
      if (viewerElement) {
        viewerElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    getOldRoundSrc(round) {
      if (round.type == "f2f" && round.feedback == null) {
        return require("../../../assets/talentpool/greyf2f.svg");
      } else if (round.type == "f2f" && round.feedback != null) {
        return require("../../../assets/talentpool/face2face.svg");
      } else if (round.type == "assesment" && round.feedback == null) {
        return require("../../../assets/talentpool/gray-assessment.svg");
      } else if (round.type == "assesment" && round.feedback != null) {
        return require("../../../assets/talentpool/face2face.svg");
      } else if (round.historyType == 2 && round.note == null) {
        return require("../../../assets/new-icons/attachment.svg");
      } else if (round.historyType == 2 && round.media.length === 0) {
        return require("../../../assets/new-icons/note.svg");
      }
    },
    getNewRoundSrc(round) {
      if (round.movementType == 23 || round.movementType == 14) {
        return require("../../../assets/new-icons/position-id.svg");
      } else if (round.movementType == 22) {
        return require("../../../assets/talentpool/rejected.svg");
      } else if (round.movementType == 21) {
        return require("../../../assets/new-icons/not-interested.svg");
      } else if (round.movementType == 19) {
        return require("../../../assets/talentpool/onhold.svg");
      } else if (round.movementType == 20 || round.movementType == 12) {
        return require("../../../assets/talentpool/selected.svg");
      } else if (round.movementType == 47) {
        return require("../../../assets/img/newkanban/resched-right.svg");
      } else if (round.movementType == 48) {
        return require("../../../assets/img/newkanban/resched-accpt.svg");
      } else if (round.movementType == 49) {
        return require("../../../assets/img/newkanban/resched-rej.svg");
      } else if (round.interviewType == "f2f" || round.movementType == 7) {
        return require("../../../assets/talentpool/face2face.svg");
      } else if (round.interviewType == "alreadyInterviewed") {
        return require("../../../assets/img/newkanban/already-int.svg");
      } else if (round.type == "attachment") {
        return require("../../../assets/new-icons/attachment.svg");
      } else if (round.type == "note") {
        return require("../../../assets/new-icons/note.svg");
      } else if (round.movementType == 0 || round.movementType == 2) {
        return require("../../../assets/img/newkanban/added-tojob.svg");
      } else if (round.movementType == 34 || round.movementType == 43) {
        return require("../../../assets/img/newkanban/vendor-cand-rejected.svg");
      } else if (round.movementType == 28) {
        return require("../../../assets/img/newkanban/cvs-triggered.svg");
      } else if (round.movementType == 29) {
        return require("../../../assets/img/newkanban/cvs-submitted.svg");
      } else if (round.movementType == 24) {
        return require("../../../assets/img/newkanban/documents-req.svg");
      } else if (round.movementType == 27) {
        return require("../../../assets/img/newkanban/documents-rej.svg");
      } else if (round.movementType == 26) {
        return require("../../../assets/img/newkanban/documents-acpt.svg");
      } else if (round.movementType == 25) {
        return require("../../../assets/img/newkanban/documents-sub.svg");
      } else if (round.movementType == 11) {
        return require("../../../assets/img/newkanban/assess-trigger.svg");
      } else if (round.movementType == 31) {
        return require("../../../assets/img/newkanban/assess-sub.svg");
      } else if (round.movementType == 32 || round.movementType == 8) {
        return require("../../../assets/img/newkanban/assess-eval.svg");
      } else if (round.movementType == 33 || round.movementType == 42) {
        return require("../../../assets/img/newkanban/cand-qualified.svg");
      } else if (round.movementType == 35) {
        return require("../../../assets/img/newkanban/vendor-pushed.svg");
      } else if (round.movementType == 15) {
        return require("../../../assets/img/newkanban/ofr-ltr-issued.svg");
      } else if (round.movementType == 16) {
        return require("../../../assets/img/newkanban/cand-onboarded.svg");
      } else if (round.movementType == 44) {
        return require("../../../assets/img/newkanban/screening-send.svg");
      } else if (round.movementType == 46) {
        return require("../../../assets/img/newkanban/screening-reject.svg");
      } else if (round.movementType == 45) {
        return require("../../../assets/img/newkanban/screening-acpt.svg");
      }
    },
    getFinalRoundSrc(status) {
      let src;
      switch (status) {
        case 1:
          src = require("../../../assets/img/newvendorflow/selectedtick.svg");
          break;
        case 2:
          src = require("../../../assets/img/newvendorflow/nitick.svg");
          break;
        case 3:
          src = require("../../../assets/img/newvendorflow/rejectedtick.svg");
          break;
        case 4:
          src = require("../../../assets/img/newvendorflow/onholdtick.svg");
          break;
        default:
          src = "";
      }
      return src;
    },
    getFeedbackSrc(round) {
      if (!round.state) {
        return require("../../../assets/new-icons/position-id.svg");
      } else if (round.state == "R") {
        return require("../../../assets/talentpool/rejected.svg");
      } else if (round.state == "NI") {
        return require("../../../assets/new-icons/not-interested.svg");
      } else if (round.state == "H") {
        return require("../../../assets/talentpool/onhold.svg");
      } else if (round.state == "F") {
        return require("../../../assets/talentpool/selected.svg");
      }
    },
    roundType(round) {
      if (round.type == "f2f") {
        return `Round ${round.id} - Face to Face`;
      } else if (round.type == "assesment") {
        return `Round ${round.id} -  Assessment`;
      } else if (round.historyType == 2 && round.note == null) {
        return "Attachment";
      } else if (round.historyType == 2 && round.media.length === 0) {
        return "Note";
      } else if (round.historyType == 3 && !round.state) {
        return "Position ID change";
      } else round.description;
    },
    oldRoundType(round) {
      if (round.interviewType) {
        return `Round ${round.interviewRound} - ${round.description}`;
      } else return round.description;
    },
    showSubName(round) {
      return (
        (round.interviewType &&
          (round.movementType != "31" || round.movementType != "11")) ||
        ["note", "attachment", "position", "pos", "resume_screening"].includes(
          round.type
        ) ||
        ["33", "34", "42", "43", "35", "14"].includes(round.movementType)
      );
    },
    showTextCat2(round) {
      return (
        ["note", "attachment", "position", "pos", "resume_screening"].includes(
          round.type
        ) ||
        (round.interviewType &&
          round.interviewType != "alreadyInterviewed" &&
          round.additionalInformation.interviewType != "cvs") ||
        ["33", "34", "42", "43", "35", "14"].includes(round.movementType)
      );
    },
    cat1SubText(round) {
      let text = "By: ";
      if (round.movementType == "0") text = `Added by : `;
      // else if (round.movementType == "8") text = `Rejected by : `;
      else if (round.movementType == "24" || round.movementType == "36")
        text = `Requested by : `;
      else if (round.movementType == "25" || round.movementType == "37")
        text = `Evaluation Pending`;
      else if (["26", "27", "38", "39", "40"].includes(round.movementType))
        text = `Evaluated by : `;
      else if (round.movementType == "16") {
        text = `Onboarded Date : `;
      }
      return text;
    },
    getAttachements(round) {
      // let names = [];
      // for (let index in round.media) {
      //   names.push(this.getFileNameFromLink(round.media[index]));
      // }
      return this.getFileNameFromLink(round?.media[0]);
    },
    previewType(round) {
      let link = this.getAttachements(round);
      let fileExtension = this.getFileType(link);
      return fileExtension;
    },
    getFileNameFromLink(fileName) {
      return fileName
        .substring(fileName.lastIndexOf("/") + 1)
        .split("?")[0]
        .replace(/%20/g, " ");
    },
    getUpcomingRoundSrc(round) {
      if (round.type == "f2f") {
        return require("../../../assets/talentpool/greyf2f.svg");
      } else {
        return require("../../../assets/talentpool/gray-assessment.svg");
      }
    },
    getFinalStatus(round) {
      if (round.state == "R") {
        return "Rejected";
      } else if (round.state == "H") {
        return "On hold";
      } else if (round.state == "NI") {
        return "Not Interested";
      } else {
        return "Selected";
      }
    },
    async getHTMLWithInlineStyles(
      el,
      allowedProps = [
        "font-family",
        "font-size",
        "font-weight",
        "color",
        "background-color",
        "padding",
        "margin",
        "display",
        "align-items",
        "justify-content",
        "gap",
        "font-style",
        "text-align",
        "width",
        "border-bottom",
      ]
    ) {
      const clone = el.cloneNode(true);

      clone.querySelectorAll(".remove-from-export").forEach((node) => {
        node.style.visibility = "hidden"; // hides content but keeps space
      });

      const walk = (source, target) => {
        const computed = window.getComputedStyle(source);
        if (!source.classList.contains("outer-cont")) {
          target.classList.add("no-break");
        }

        allowedProps.forEach((prop) => {
          if (prop === "width") return;
          const value = computed.getPropertyValue(prop);
          if (
            value &&
            value !== "initial" &&
            value !== "0px" &&
            value !== "none"
          ) {
            target.style.setProperty(prop, value);
          }
        });
        const classList = Array.from(source.classList);
        const widthClass = classList.find((c) => /^w-\d+$/.test(c));
        if (widthClass) {
          const percent = widthClass.split("-")[1];
          target.style.setProperty("width", `${percent}%`);
        }
        const sourceChildren = Array.from(source.children);
        const targetChildren = Array.from(target.children);

        for (let i = 0; i < sourceChildren.length; i++) {
          if (targetChildren[i]) {
            walk(sourceChildren[i], targetChildren[i]);
          }
        }
      };

      walk(el, clone);
      await this.embedImagesToBase64(clone);

      clone.querySelectorAll(".email-prot").forEach((emailEl) => {
        const content = emailEl.innerHTML;
        emailEl.innerHTML = `<!--email_off-->${content}<!--/email_off-->`;
      });
      return clone.outerHTML;
    },
    async embedImagesToBase64(root) {
      const imgElements = root.querySelectorAll("img");

      for (let img of imgElements) {
        const src = img.getAttribute("src");

        // Skip if already base64
        if (!src || src.startsWith("data:")) continue;

        try {
          const absoluteURL = img.src; // resolves relative path
          const response = await fetch(absoluteURL);
          const blob = await response.blob();

          const base64 = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });

          img.setAttribute("src", base64);
        } catch (err) {
          console.warn(`Failed to embed image ${src}`, err);
        }
      }
    },
    async downloadJobHistory(data) {
      this.historyLoading = true;
      this.downloadingJob = data.jobID;
      const el = this.$refs.timelineBlock[this.selectedJobInd];
      const styledHtml = await this.getHTMLWithInlineStyles(el);
      this.getHistoryHtml(data.jobID, styledHtml);

      // let payload = {
      //   emailID: this.candidateData.email,
      //   jobID: data.jobID,
      // };
      // const res = await getCandidateSummary(payload);
      // if (res.status === 200) {
      //   const blob = new Blob([res.data], { type: "application/octet-stream" });
      //   const link = document.createElement("a");
      //   link.href = URL.createObjectURL(blob);
      //   link.download = `${this.candidateData.name}.pdf`;
      //   link.click();
      // }
    },
    viewFeedback(round) {
      this.singleFeedbackData =
        this.selectedJob.jobHistoryVersion == "v3"
          ? { feedBackForm: round.feedback }
          : round.feedback;
      if (round.automatic) this.singleFeedbackData.automatic = round.automatic;
      this.singleBasicInfo = {};
      this.singleBasicInfo["name"] = this.candidateData.name;
      this.singleBasicInfo["evalDate"] =
        this.singleFeedbackData.feedBackForm.createdAt || round.createdAt;
      this.singleBasicInfo["panel"] =
        this.singleFeedbackData.feedBackForm.panelName;
      this.singleBasicInfo["modeOfInterview"] =
        round.interviewType || round.type;
      this.singleBasicInfo["action"] =
        this.singleFeedbackData.feedBackForm.recommendation;
      this.singleBasicInfo["remarks"] =
        this.singleFeedbackData.feedBackForm.recruiterRemarks;
      this.singleBasicInfo["feedback"] =
        this.singleFeedbackData.assessmentResponse;
      this.singleFeedbackModal = true;
    },
    goToCandidateProfile() {
      if (this.vendor || this.roles.includes("GET_VENDOR_DASHBOARD")) {
        window.open(this.candidateData.publicProfile);
      } else {
        let from =
          this.$route.name == "TalentPool" &&
          this.roles.includes("GET_VENDOR_DASHBOARD")
            ? "vendortalentpool"
            : this.$route.name == "TalentPool"
            ? "talentpool"
            : "kanban";
        let query1 = {
          from: from,
        };
        let query = {
          from: from,
          jobID: this.particularJob.jobID,
        };

        query.cardName = this.$route.query.cardName;
        query.itype = this.$route.query.itype;
        query.customerID = this.$route.query.customerID;
        this.$router.push({
          name: "ViewCandidateProfile",
          params: {
            email: this.candidateData.email,
          },
          query: from.endsWith("talentpool") ? query1 : query,
        });
      }
    },
    closeSingleFeedbackModal() {
      this.historyRound = null;
      this.singleFeedbackModal = false;
    },
    activateCand() {
      this.$router.push({
        name: "ActivateCandidate",
        params: {
          candidateID: this.candidateData.candidateID,
        },
        query: {
          active: "" + this.candidateData.active,
        },
      });
    },
    async downloadFile(field, from) {
      let payload;
      if (from) payload = field;
      else if (field.fieldType != "default") {
        payload = this.candidateData.customFields[field.key];
      } else {
        payload = this.candidateData[field.key];
      }
      const res = await downloadAnyFile(payload);
      if (res.status == 200) {
        const link = res.data.data.downloadLink;
        if (!from) {
          // implemented bcz once we click on download resume that page shouldn't go blank
          const candidateName = res.data.data.name;

          // Create a dynamic file name based on the candidate's name and email
          const fileName = `${candidateName}_${field.label}.pdf`;

          // Create an anchor element
          const a = document.createElement("a");
          a.href = link;
          a.download = fileName; // Set the dynamically generated file name

          // Trigger a click event on the anchor element
          a.click();
        } else this.previewImageFiles("Image", link);
        // this.successModal("Resume downloaded successfully");
      }
    },
    previewPdfFiles(label, link) {
      this.previewLabel = label;
      this.previewLink = link;
      this.viewResume = true;
    },
    previewImageFiles(label, link) {
      this.previewLabel = label;
      this.previewImgLink = link;
      this.viewImage = true;
    },
    getTextColor(status) {
      let style;
      switch (status) {
        case 1:
          style = "color : #038E00";
          break;
        case 2:
          style = "color : #424273";
          break;
        case 3:
          style = "color : #EB0002";
          break;
        case 4:
          style = "color : #FFC145";
          break;
        default:
          style = "";
      }
      return style;
    },
    showBotAnalysis(round) {
      return (
        ["7", "11", "10"].includes(round.movementType) &&
        this.roles.includes("VIEW_CANDIDATE_ANALYSIS") &&
        round.botInfo &&
        round.botInfo.botAnalysisCompleted &&
        round.botInfo.aiInterviewer
      );
    },
    goToBotAnalysis(round) {
      const params = new URLSearchParams(round.botInfo.botPreviewQuery);
      const interviewID = params.get("interviewID");
      let queryData = {
        intid: interviewID,
        type: 1,
        fromkanban: this.$route.name == "Kanban" ? true : false,
        fromPage: this.$route.name,
        candidateID: this.selectedCandidate.candidateID,
        preview: true,
        intparams: round.botInfo.botPreviewQuery,
      };
      queryData = {
        ...queryData,
        ...this.$route.query,
      };
      delete queryData.history;
      this.storeCandData();
      this.$router.push({
        name: "BotAnalysis",
        query: queryData,
      });
    },
  },
};
</script>

<style>
.report-fit-band {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 13px;
  background: #f6f9fb;
  border-radius: 8px;
}
.preview-cand-top-btns-cont {
  gap: 15px;
}
.preview-cand-top-btns {
  position: relative;
  color: #20639b;
  font-weight: 600;
  font-size: 13px;
}
.preview-cand-vert-line {
  background: #d7d7d7;
  height: 10px;
  width: 2px;
}
.preview-cand-top-btns::after {
  content: "";
  width: 1px;
  height: 22px;
  background: #d7d7d7;
  position: absolute;
  display: block;
  right: -12px;
  top: -2px;
}

.h-85 {
  height: 85%;
}

.overall-font {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #8c8c8c;
}

.fail-card {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 10px;
  background: rgba(235, 0, 2, 0.1);
  border-radius: 4px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #eb0002;
}

.req-head {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #000000;
}

.req-subhead {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #3a3c40;
}

.re-trigger-div {
  box-shadow: 0px 4px 8px 0px #00000029;
}

.submitted-font {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.date-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1px 10px;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 4px;
}

.date-container-font {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #333333;
}

.cvs-loader-button {
  opacity: 0.5;
  height: 29px;
  width: 150px;
}

.cvs-send-loader {
  position: absolute;
  z-index: 1;
  top: -55px;
  left: 33px;
}

.position-change-txt {
  color: #8c8c8c !important;
  font-style: italic;
}
.docs-card .card {
  box-sizing: border-box;
  background: rgba(32, 99, 155, 0.09);
  border-radius: 4px;
  padding: 10px;
  border: unset;
  box-shadow: none;
}

.docs-card .card-body {
  padding: 0;
  display: flex;
  align-items: center;
}
.highlight {
  font-family: "Lato", sans-serif;
  font-size: 11px;
  font-style: italic;
  font-weight: 500;
  color: #3a3c40;
}

.candidate-notes-head {
  font-family: var(--lato);
  font-weight: 600;
  font-size: var(--size-14);
  color: var(--bluetheme);
}

.pcs-doc-cards {
  background-color: #ffffff;
  box-shadow: 0px 1px 8px 0px #0000002b;
  border-radius: 8px;
  padding: 12px 10px;
}
.pcs-doc-cards div {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  line-height: 16px;
}
.pcs-doc-cards span {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-style: italic;
  font-size: 11px;
  letter-spacing: 0%;
  color: #8c8c8c80;
}
.pcs-doc-title {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #344054;
}
.pcs-doc-dropdown {
  max-height: 183px;
  top: 95px;
  left: 174px;
}
.pcs-arrow {
  transition: transform 0.5s ease;
  transform: rotate(180deg);
}
.pcs-doc-shadow {
  box-shadow: 0px 4.15px 18.7px 0px #00000036;
  border-radius: 8px;
  overflow: hidden;
  height: fit-content;
}
.pcs-doc-overflow {
  height: calc(100vh - 335px);
  overflow: auto;
  padding-block: 10px;
}

.candidate-notes-head {
  font-family: var(--lato);
  font-weight: 600;
  font-size: var(--size-14);
  color: var(--bluetheme);
}

.notes-tags-container {
  padding: 12px;
  background: #f6f9fb;
  border-radius: 8px;
}
.pc-notes-tabs .card-header {
  padding: 2px;
  background-color: #f4f4f4;
  border: 1px solid rgba(140, 140, 140, 0.2);
  border-radius: 5px;
}
.pc-notes-tabs .nav-link {
  display: block;
  padding: 5px 25px;
  cursor: pointer;
}
.pc-notes-tabs .nav-item {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: -0.08px;
  color: #595959;
}
.pc-notes-tabs .card-header-pills {
  margin: 0;
}
.pc-notes-tabs .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background: #20639b;
  border-radius: 3px;
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: -0.08px;
  color: #ffffff;
}
.pc-notes-tabs a {
  all: unset;
}

.pc-notes-full .tab-content {
  height: calc(100vh - 340px) !important;
}

.pc-notes-tabs .tab-content {
  position: absolute;
  top: 68px;
  width: 104%;
  left: 0;
  /* height: 100%; */
  height: calc(100vh - 435px);
  overflow: auto;
  padding-right: 17px;
  /* height: calc(100% - var(--pc-tags-height));
  overflow-y: auto; */
}
.pc-notes-tabs .card-body {
  padding: 0;
}
.notes-category-box {
  padding: 16px;
  background: #fcfcfc;
  border: 1px solid rgba(140, 140, 140, 0.33);
  border-radius: 8px;
}
.pc-notes-tags-overflow {
  max-height: 75px;
  min-height: auto;
  overflow: auto;
}
.kanban-skeleton-cards {
  box-shadow: 0px 4px 5px 1px #6f6f6f2b;
  border: 1px solid #8c8c8c26;
  border-radius: 8px;
  width: 100%;
  padding: 10px;
}

.blue-spinner .spinner-border {
  display: inline-block;
  width: 1.1rem;
  height: 1.1rem;
  vertical-align: text-bottom;
  border: 0.2em solid rgb(32 99 155);
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
  margin-top: 1.5px;
}
.download-btn .icon {
  width: 15px;
  height: 12px;
  animation: dropDown 1.2s ease-in-out infinite;
}

/* Drop-down animation */
@keyframes dropDown {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }
  30% {
    transform: translateY(0);
    opacity: 1;
  }
  60% {
    transform: translateY(3px);
  }
  100% {
    transform: translateY(-10px);
    opacity: 0;
  }
}
.icon-position {
  margin-top: 2px;
  width: 16px;
}

.cvs-list-drop {
  min-height: auto;
  max-height: calc(100vh - 535px);
  overflow: auto;
  border-radius: 8px;
}
</style>
